export default {
    hostList : {
        hostFamous:[`安庆-安庆市第一人民医院`,`安庆-安庆市立医院`,`安庆-安庆中医院`,`蚌埠-蚌埠市三人民医院`,`蚌埠-蚌埠医学院第一附属医院`,`巢湖-巢湖市第一人民医院`,`池州-池州市人民医院`,`滁州-滁州市第一人民医院`,`阜阳-阜阳市人民医院`,`阜阳-太和中医院`,`合肥-安徽省儿童医院`,`合肥-安徽省立医院`,`合肥-安徽省中医院`,`合肥-安徽医科大学第二附属医院`,`合肥-安徽医科大学第四附属医院`,`合肥-安徽医科大学第一附属医院`,`合肥-安徽中医药大学第一附属医院`,`合肥-合肥市第二人民医院`,`合肥-合肥市第一人民医院`,`淮北-淮北矿工总医院`,`淮北-淮北市人民医院`,`淮北-淮北中医医院`,`黄山-黄山市人民医院`,`六安-六安市人民医院`,`马鞍山-马鞍山市人民医院`,`马鞍山-马鞍山市中心医院`,`铜陵-铜陵市人民医院`,`芜湖-皖南医学院附属弋矶山医院`,`芜湖-芜湖市第二人民医院`,`芜湖-芜湖市第一人民医院`,`芜湖-芜湖市中医院`,`北京-北京安定医院`,`北京-北京安贞医院`,`北京-北京朝阳医院`,`北京-北京大学第六医院`,`北京-北京大学第三医院`,`北京-北京大学第一医院`,`北京-北京大学口腔医院`,`北京-北京大学人民医院`,`北京-北京大学首钢医院`,`北京-北京大学肿瘤医院`,`北京-北京地坛医院`,`北京-北京儿童医院`,`北京-北京妇产医院`,`北京-北京阜外医院`,`北京-北京复兴医院`,`北京-北京回龙观医院`,`北京-北京积水潭医院`,`北京-北京结核病控制研究所`,`北京-北京军区总医院`,`北京-北京口腔医院`,`北京-北京世纪坛医院`,`北京-北京市昌平区中西医结合医院`,`北京-北京市第一中西医结合医院`,`北京-北京市肛肠医院`,`北京-北京市公安医院`,`北京-北京市急救中心`,`北京-北京天坛医院`,`北京-北京铁路总医院`,`北京-北京同仁医院`,`北京-北京武警总队第三医院`,`北京-北京协和医院`,`北京-北京胸科医院`,`北京-北京宣武医院`,`北京-北京医院`,`北京-北京友谊医院`,`北京-北京佑安医院`,`北京-北京中日友好医院`,`北京-北京中医药大学第三附属医院`,`北京-北京中医药大学东方医院`,`北京-北京中医药大学东直门医院`,`北京-北京中医医院`,`北京-北京肿瘤医院`,`北京-海军总医院`,`北京-火箭军总医院`,`北京-解放军总医院第一附属医院`,`北京-空军航空医学研究所附属医院 `,`北京-空军总医院`,`北京-陆军总医院附属八一儿童医院`,`北京-陆军总医院附属八一脑科医院`,`北京-煤炭总医院`,`北京-首都儿科研究所附属儿童医院`,`北京-武警北京市总队第二医院`,`北京-武警北京市总队医院`,`北京-中国康复研究中心`,`北京-中国人民解放军第302医院`,`北京-中国人民解放军第305医院`,`北京-中国人民解放军第306医院`,`北京-中国人民解放军第307医院`,`北京-中国人民解放军第309医院`,`北京-中国人民解放军总医院`,`北京-中国人民武装警察部队北京市总队第二医院`,`北京-中国人民武装警察部队北京市总队第三医院`,`北京-中国武警总医院`,`北京-中国医学科学院阜外心血管病医院`,`北京-中国医学科学院整形外科医院`,`北京-中国医学科学院肿瘤医院`,`北京-中国中医科学院广安门医院`,`北京-中国中医科学院望京医院`,`北京-中国中医科学院西苑医院`,`北京-中国中医科学院眼科医院`,`北京-中国中医科学院中医门诊部`,`北京-中日友好医院`,`福州-福建省第二人民医院　`,`福州-福建省福州儿童医院`,`福州-福建省福州肺科医院`,`福州-福建省福州神经精神病防治院`,`福州-福建省妇幼保健院 `,`福州-福建省立医院`,`福州-福建省中医药大学院附属人民医院`,`福州-福建省肿瘤医院`,`福州-福建医科大学附属第二医院`,`福州-福建医科大学附属第一医院`,`福州-福建医科大学附属口腔医院`,`福州-福建医科大学附属协和医院`,`福州-福建医科大学孟超肝胆医院`,`福州-福州市第二医院`,`福州-福州市第一医院`,`福州-福州市妇幼保健院`,`福州-南京军区福州总医院`,`福州-中国人民解放军第175医院`,`龙岩-龙岩市第一医院`,`南平-南平市第一医院`,`宁德-宁德市闽东医院`,`莆田-莆田市第一医院`,`莆田-莆田学院附属医院`,`泉州-泉州市第一医院`,`三明-三明市第一医院`,`厦门-厦门大学附属成功医院`,`厦门-厦门大学附属第一医院`,`厦门-厦门大学附属厦门眼科中心 `,`厦门-厦门大学附属中山医院`,`厦门-厦门市妇幼保健院`,`厦门-厦门市口腔医院`,`厦门-厦门市仙岳医院`,`厦门-厦门市长庚医院`,`厦门-厦门市中医院`,`漳州-漳州市医院`,`漳州-漳州中医院`,`酒泉-酒泉市人民医院`,`兰州-甘肃省康复中心医院`,`兰州-甘肃省人民医院`,`兰州-甘肃省中医院`,`兰州-甘肃省肿瘤医院`,`兰州-兰州大学第二医院`,`兰州-兰州大学第一医院`,`兰州-兰州第一人民医院`,`兰州-兰州军区总医院`,`兰州-兰州市第一人民医院`,`兰州-中国人民解放军第四七三医院`,`兰州-中国人民解放军第一医院`,`平凉-平凉市人民医院`,`庆阳-庆阳市人民医院`,`天水-天水市第一人民医院`,`天水-天水市中西医医院`,`张掖-张掖市人民医院`,`潮州-潮州市中心医院`,`东莞-东莞市第五人民医院`,`东莞-东莞市东华医院`,`东莞-东莞市妇幼保健院`,`东莞-东莞市厚街医院`,`东莞-东莞市康华医院`,`东莞-东莞市人民医院`,`东莞-东莞市石龙人民医院`,`东莞-东莞市中医院`,`佛山-佛山市禅城区中心医院`,`佛山-佛山市第二人民医院`,`佛山-佛山市第一人民医院`,`佛山-佛山市妇幼保健院`,`佛山-佛山市高明区人民医院`,`佛山-佛山市南海区妇幼保健院`,`佛山-佛山市南海区人民医院`,`佛山-佛山市顺德区妇幼保健院`,`佛山-佛山市中医院`,`佛山-南方医科大学顺德医院`,`广州-广东祈福医院`,`广州-广东三九脑科医院`,`广州-广东省第二人民医院`,`广州-广东省第二中医院`,`广州-广东省妇幼保健院`,`广州-广东省口腔医院`,`广州-广东省人民医院`,`广州-广东省中医院`,`广州-广东药科大学附属第一医院`,`广州-广州红十字会医院`,`广州-广州解放军军体医院`,`广州-广州军区广州总医院`,`广州-广州军区机关医院肝病中心`,`广州-广州市第八人民医院`,`广州-广州市第二人民医院`,`广州-广州市第十二人民医院`,`广州-广州市第一人民医院`,`广州-广州市番禺区中心医院`,`广州-广州市妇女儿童医疗中心`,`广州-广州市红十字会医院`,`广州-广州市惠爱医院`,`广州-广州市南沙中心医院`,`广州-广州市胸科医院`,`广州-广州市中医医院`,`广州-广州铁路中心医院`,`广州-广州医科大学附属第二医院`,`广州-广州医科大学附属第三医院`,`广州-广州医科大学附属第一医院`,`广州-广州中医药大学第三附属医院`,`广州-广州中医药大学第一附属医院`,`广州-暨南大学附属第一医院`,`广州-南部战区空军医院`,`广州-南方医科大学第三附属医院`,`广州-南方医科大学附属南方医院`,`广州-南方医科大学附属珠江医院`,`广州-南方医科大学中西医结合医院`,`广州-武警广东总队医院`,`广州-中国人民解放军第157医院`,`广州-中国人民解放军第421医院`,`广州-中山大学附属第二医院`,`广州-中山大学附属第六医院`,`广州-中山大学附属第三医院`,`广州-中山大学附属第一医院`,`广州-中山大学附属口腔医院`,`广州-中山大学附属肿瘤医院`,`广州-中山大学孙逸仙纪念医院`,`广州-中山大学中山眼科中心 `,`河源-河源市人民医院`,`惠州-惠州市第三人民医院`,`惠州-惠州市第一人民医院`,`惠州-惠州市中心人民医院`,`惠州-惠州市中医院`,`惠州-中国人民解放军第一七三医院`,`江门-江门市人民医院`,`江门-江门市五邑中医院`,`江门-江门市中心医院`,`江门-开平市中心医院`,`揭阳-揭阳市人民医院`,`揭阳-普宁市人民医院`,`罗定-罗定市人民医院`,`茂名-茂名市人民医院`,`茂名-茂名市中医院`,`梅州-梅州市人民医院`,`清远-清远市人民医院`,`清远-清远市中医院`,`汕头-汕头大学第二附属医院`,`汕头-汕头大学医学院第一附属医院`,`汕头-汕头市中心医院`,`韶关-韶关市第一人民医院`,`韶关-韶关市粤北人民医院`,`韶关-韶关市中医院`,`深圳-北京大学深圳医院`,`深圳-广州中医药大学深圳附属医院`,`深圳-深圳儿童医院`,`深圳-深圳龙岗中心医院`,`深圳-深圳市宝安区人民医院`,`深圳-深圳市第二人民医院`,`深圳-深圳市第一人民医院`,`深圳-深圳市儿童医院`,`深圳-深圳市妇儿医院`,`深圳-深圳市妇幼保健院`,`深圳-深圳市龙岗中心医院`,`深圳-深圳市南山区人民医院`,`深圳-深圳市人民医院`,`深圳-深圳市孙逸仙心血管医院`,`深圳-深圳市眼科医院`,`深圳-深圳市中医院`,`深圳-香港大学深圳医院`,`阳江-阳江市人民医院`,`阳江-阳江市中医医院`,`湛江-广东省农垦中心医院`,`湛江-广东医科大学附属医院`,`湛江-湛江市第二人民医院`,`湛江-湛江市第一中医医院`,`湛江-湛江中心人民医院`,`湛江-中国人民解放军第196医院`,`湛江-中国人民解放军第422医院`,`肇庆-肇庆市第一人民医院`,`肇庆-肇庆市中医院`,`中山-中山市博爱医院`,`中山-中山市人民医院`,`中山-中山市小榄人民医院`,`中山-中山市中医院`,`珠海-广东省中医院珠海医院`,`珠海-中山大学附属第五医院`,`珠海-珠海市第二人民医院`,`珠海-珠海市第一人民医院`,`珠海-珠海市妇幼保健院`,`珠海-珠海市人民医院`,`百色-百色市人民医院`,`百色-右江民族医学院附属医院`,`北海-北海市人民医院`,`北海-北海市中医医院`,`贵港-贵港市人民医院`,`桂林-广西壮族自治区南溪山医院`,`桂林-桂林市第二人民医院`,`桂林-桂林市人民医院`,`桂林-桂林市中医院`,`桂林-桂林医学院附属医院`,`桂林-中国人民解放军第181医院`,`河池-河池市人民医院`,`柳州-柳州市妇幼保健院`,`柳州-柳州市工人医院`,`柳州-柳州市柳铁中心医院`,`柳州-柳州市人民医院`,`柳州-柳州市中医院`,`柳州-柳州医学高等专科学校第一附属医院`,`南宁-广西医科大学第一附属医院`,`南宁-广西医科大学附属口腔医院`,`南宁-广西医科大学附属肿瘤医院`,`南宁-广西中医药大学附属瑞康医院`,`南宁-广西壮族自治区妇幼保健院`,`南宁-广西壮族自治区工人医院`,`南宁-广西壮族自治区民族医院`,`南宁-广西壮族自治区人民医院`,`南宁-南宁市第二人民医院`,`南宁-南宁市第一人民医院`,`南宁-中国人民解放军第303医院`,`钦州-钦州市第二人民医院`,`钦州-钦州市第一人民医院`,`梧州-梧州市工人医院`,`玉林-玉林市第一人民医院`,`安顺-安顺市人民医院`,`毕节-毕节市人民医院`,`都匀-黔南布依族苗族自治州人民医院`,`贵阳-贵阳市第二人民医院`,`贵阳-贵阳市第四人民医院`,`贵阳-贵阳市第一人民医院`,`贵阳-贵阳市妇幼保健院贵阳市儿童医院`,`贵阳-贵阳市口腔医院`,`贵阳-贵阳中医学院第二附属医院`,`贵阳-贵阳中医学院第一附属医院`,`贵阳-贵州省骨科医院`,`贵阳-贵州省人民医院`,`贵阳-贵州省肿瘤医院`,`贵阳-贵州医科大学第二附属医院`,`贵阳-贵州医科大学第三附属医院`,`贵阳-贵州医科大学附属医院`,`贵阳-武警贵州总队医院`,`六盘水-六盘水市人民医院`,`黔东南苗族侗族自治州-黔东南苗族侗族自治州人民医院`,`黔西南布依族苗族自治州-黔西南布依族苗族自治州人民医院`,`铜仁-铜仁市第一人民医院`,`兴义-兴义市人民医院`,`遵义-遵义市第一人民医院`,`遵义-遵义市中医院`,`遵义-遵义医学院附属口腔医院`,`遵义-遵义医学院附属医院`,`海口-海口市人民医院`,`海口-海南省农垦总医院`,`海口-海南省人民医院`,`海口-海南省中医院`,`海口-海南医学院第一附属医院`,`海口-中国人民解放军第187中心医院`,`三亚-海南省农垦三亚医院`,`保定-保定市第二医院`,`保定-保定市第一中心医院`,`保定-保定市第一中医院`,`保定-保定市妇幼保健院`,`保定-保定涿州市医院`,`保定-河北大学附属医院`,`保定-河北省第六人民医院`,`保定-河北省第一医院`,`保定-中国人民解放军第二五二医院`,`沧州-沧州市二医院`,`沧州-沧州市人民医院`,`沧州-沧州市中西医结合医院`,`沧州-沧州市中心医院`,`承德-承德市中心医院`,`承德-承德市中医院`,`承德-承德医学院附属医院`,`承德-中国人民解放军第266医院`,`邯郸-邯郸市第一医院`,`邯郸-邯郸市中心医院`,`邯郸-邯郸市中医院`,`邯郸-邯郸市肿瘤医院`,`邯郸-河北工程大学附属医院`,`邯郸-冀中能源峰峰集团有限公司总医院`,`衡水-衡水市人民医院`,`廊坊-廊坊市妇幼保健中心`,`廊坊-廊坊市人民医院`,`廊坊-廊坊市中医院`,`廊坊-中国石油天然气集团公司中心医院`,`秦皇岛-秦皇岛妇幼保健院`,`秦皇岛-秦皇岛市第一医院`,`秦皇岛-秦皇岛市中医院`,`任丘-华北石油管理局总医院`,`石家庄-河北省儿童医院`,`石家庄-河北省人民医院`,`石家庄-河北省中医院`,`石家庄-河北医科大学第二医院`,`石家庄-河北医科大学第三医院`,`石家庄-河北医科大学第四医院`,`石家庄-河北医科大学第一医院`,`石家庄-河北医科大学中医学院附属医院`,`石家庄-石家庄市第四医院`,`石家庄-石家庄市第一医院`,`石家庄-中国人民解放军白求恩国际和平医院`,`唐山-河北联合大学附属医院`,`唐山-华北煤炭医学院附属医院`,`唐山-开滦总医院`,`唐山-唐山市第四医院`,`唐山-唐山市妇幼保健院`,`唐山-唐山市工人医院`,`唐山-唐山市人民医院`,`唐山-唐山市中医医院`,`邢台-邢台市人民医院`,`张家口-河北北方学院附属第一医院`,`张家口-中国人民解放军第251医院`,`安阳-安阳市人民医院`,`安阳-安阳市中医院`,`安阳-安阳市肿瘤医院`,`安阳-濮阳市安阳地区医院`,`焦作-焦作市第二人民医院`,`焦作-焦作市第三人民医院`,`焦作-焦作市人民医院`,`开封-河南大学附属医院`,`开封-河南大学淮河医院`,`开封-开封市第一人民医院`,`洛阳-河南科技大学第一附属医院`,`洛阳-洛阳第一中医院`,`洛阳-洛阳市中心医院`,`洛阳-洛阳正骨医院`,`洛阳-中国人民解放军第一五Ｏ中心医院`,`漯河-漯河市中心医院`,`南阳-南阳市第二人民医院`,`南阳-南阳市中心医院`,`平顶山-河南省平顶山市煤业集团公司总医院`,`平顶山-平顶山市第一人民医院`,`平顶山-中平能化医疗集团总医院`,`濮阳-濮阳市人民医院`,`濮阳-濮阳市油田总医院`,`新乡-河南省精神病医院`,`新乡-新乡市中心医院`,`新乡-新乡医学院第一附属医院`,`郑州-河南省人民医院`,`郑州-河南省胸科医院`,`郑州-河南省中医院`,`郑州-河南省肿瘤医院`,`郑州-河南中医药大学第一附属医院`,`郑州-武警河南省总队医院`,`郑州-郑州大学第三附属医院`,`郑州-郑州大学第五附属医院`,`郑州-郑州大学第一附属医院`,`郑州-郑州人民医院`,`郑州-郑州市儿童医院`,`郑州-郑州市骨科医院`,`郑州-郑州市中心医院`,`郑州-郑州市中医院`,`郑州-中国人民解放军第153中心医院`,`周口-周口市中心医院`,`大庆-大庆龙南医院`,`大庆-大庆市第三医院`,`大庆-大庆市人民医院`,`大庆-大庆市中医院`,`大庆-大庆油田总医院`,`哈尔滨-哈尔滨二四二医院`,`哈尔滨-哈尔滨市第二医院`,`哈尔滨-哈尔滨市第三医院`,`哈尔滨-哈尔滨市第四医院`,`哈尔滨-哈尔滨市第五医院`,`哈尔滨-哈尔滨市第一医院`,`哈尔滨-哈尔滨市第一专科医院`,`哈尔滨-哈尔滨市儿童医院`,`哈尔滨-哈尔滨市骨伤医院`,`哈尔滨-哈尔滨市红十字中心医院`,`哈尔滨-哈尔滨市神经精神医院`,`哈尔滨-哈尔滨市胸科医院`,`哈尔滨-哈尔滨市中医院`,`哈尔滨-哈尔滨医科大学附属第二医院`,`哈尔滨-哈尔滨医科大学附属第四医院`,`哈尔滨-哈尔滨医科大学附属第一医院`,`哈尔滨-哈尔滨医科大学附属肿瘤医院`,`哈尔滨-哈尔滨中医院`,`哈尔滨-黑龙江省电力医院`,`哈尔滨-黑龙江省海员总医院`,`哈尔滨-黑龙江省康复医院`,`哈尔滨-黑龙江省林业总医院`,`哈尔滨-黑龙江省农垦总局总医院`,`哈尔滨-黑龙江省人民医院`,`哈尔滨-黑龙江省森工总医院`,`哈尔滨-黑龙江省医院`,`哈尔滨-黑龙江省中医医院`,`哈尔滨-黑龙江中医药大学附属第二医院`,`哈尔滨-黑龙江中医药大学附属第一医院`,`哈尔滨-齐齐哈尔医学院附属第四医院`,`哈尔滨-中国人民解放军第211医院`,`黑河-黑河市第二人民医院`,`黑河-黑河市第一人民医院`,`鸡西-鸡西矿业集团总医院`,`鸡西-鸡西市人民医院`,`佳木斯-黑龙江省农垦建三江管理局中心医院`,`佳木斯-佳木斯大学附属第三医院`,`佳木斯-佳木斯大学附属第一医院`,`佳木斯-佳木斯口腔医院`,`佳木斯-佳木斯市中心医院`,`佳木斯-佳木斯市中医院`,`佳木斯-佳木斯市肿瘤结核医院`,`牡丹江-牡丹江第二人民医院`,`牡丹江-牡丹江市第一人民医院`,`牡丹江-牡丹江市妇女儿童医院`,`牡丹江-牡丹江市康安医院`,`牡丹江-牡丹江市中医医院`,`牡丹江-牡丹江医学院第二附属医院`,`牡丹江-牡丹江医学院红旗医院`,`七台河-七台河矿业精煤(集团)有限责任公司总医院`,`七台河-七台河市人民医院`,`齐齐哈尔-齐齐哈尔市第一医院`,`齐齐哈尔-齐齐哈尔市中医医院`,`齐齐哈尔-齐齐哈尔医学院附属第二医院`,`齐齐哈尔-齐齐哈尔医学院附属第三医院`,`齐齐哈尔-齐齐哈尔医学院附属第一医院`,`齐齐哈尔-中国人民解放军第二Ｏ三医院`,`双鸭山-黑龙江省农垦红兴隆管理局中心医院`,`鄂州-鄂州市中心医院`,`恩施-恩施土家族苗族自治州中心医院`,`黄冈-黄冈市中心医院`,`黄石-黄石市中心医院`,`荆门-荆门市第一人民医院`,`荆州-荆州市第一人民医院`,`荆州-荆州市中心医院`,`荆州-荆州市中医院`,`潜江-湖北江汉油田总医院`,`十堰-东风汽车公司总医院`,`十堰-十堰市人民医院`,`十堰-十堰市太和医院`,`武昌-湖北中医学院附属医院`,`武汉-广州军区武汉总医院`,`武汉-湖北妇幼保健院`,`武汉-湖北省妇女儿童医院`,`武汉-湖北省人民医院`,`武汉-湖北省新华医院`,`武汉-湖北省中山医院`,`武汉-湖北省肿瘤医院`,`武汉-华中科技大学同济医学院附属梨园医院`,`武汉-华中科技大学同济医学院附属同济医院`,`武汉-华中科技大学同济医学院附属协和医院`,`武汉-武汉大学口腔医院`,`武汉-武汉大学人民医院`,`武汉-武汉大学同仁医院武汉市第三医院`,`武汉-武汉大学中南医院`,`武汉-武汉大学中山医院`,`武汉-武汉妇女儿童医疗保健中心`,`武汉-武汉钢铁（集团）公司职工总医院`,`武汉-武汉精神卫生中心`,`武汉-武汉科技大学天佑医院`,`武汉-武汉市传染病医院`,`武汉-武汉市第三医院`,`武汉-武汉市第四医院`,`武汉-武汉市妇女儿童医疗保健中心`,`武汉-武汉市精神卫生中心`,`武汉-武汉市普爱医院`,`武汉-武汉市中西医结合医院`,`武汉-武汉市中心医院`,`武汉-武汉市中医院`,`武汉-武汉铁路中心医院`,`武汉-武汉协和医院`,`武汉-武警湖北省总队医院`,`武汉-中国人民解放军第161中心医院`,`武汉-中国人民解放军第457医院`,`咸宁-咸宁市中心医院`,`襄阳-襄樊市第一人民医院`,`襄阳-襄樊市中心医院`,`襄阳-襄樊市中医院`,`襄阳-襄阳市第一人民医院`,`襄阳-襄阳市中心医院`,`襄阳-襄阳市中医医院`,`孝感-孝感市中心医院`,`宜昌-宜昌市第二人民医院`,`宜昌-宜昌市第一人民医院`,`宜昌-宜昌市中心人民医院`,`宜昌-宜昌市中医院`,`宜昌-中国葛洲坝集团中心医院`,`常德-常德市第一人民医院`,`常德-常德市第一中医院`,`郴州-郴州市第四人民医院`,`郴州-郴州市第一人民医院`,`郴州-郴州市中医院`,`衡阳-衡阳市中心医院`,`衡阳-南华大学附属第二医院`,`衡阳-南华大学附属第一医院`,`衡阳-南华大学附属南华医院`,`衡阳市-衡阳市第一人民医院`,`衡阳市-中国人民解放军第一六九中心医院`,`怀化-怀化市第一人民医院`,`娄底-娄底市中心医院`,`邵阳-邵阳市中心医院`,`湘潭-湘潭市第一人民医院`,`湘潭-湘潭市立医院`,`湘潭-湘潭市中心医院`,`益阳-益阳市中心医院`,`永州-永州市中心医院`,`岳阳-岳阳市一人民医院`,`岳阳-岳阳市中医院`,`长沙-湖南省儿童医院 `,`长沙-湖南省妇幼保健院`,`长沙-湖南省人民医院`,`长沙-湖南省中医研究院附属医院`,`长沙-湖南省肿瘤医院`,`长沙-湖南中医药大学第二附属医院`,`长沙-湖南中医药大学第一附属医院`,`长沙-长沙口腔医院`,`长沙-长沙市一医院`,`长沙-长沙市中心医院`,`长沙-中国人民解放军第163医院`,`长沙-中南大学湘雅二医院`,`长沙-中南大学湘雅三医院`,`长沙-中南大学湘雅医院`,`株洲-湖南省直中医医院`,`株洲-株洲市人民医院`,`株洲-株洲市一医院`,`株洲-株洲市中心医院`,`吉林-北华大学附属医院`,`吉林-吉化集团公司总医院`,`吉林-吉林省精神神经病医院`,`吉林-吉林市人民医院`,`吉林-吉林市医学院附属医院`,`吉林-吉林市中西医结合医院`,`吉林-吉林市中心医院`,`吉林-吉林铁路中心医院`,`吉林-吉林医药学院附属医院`,`吉林-中国人民解放军第二二二医院`,`四平-四平市中心医院`,`松原-吉林油田总医院`,`通化-梅河口市医院`,`通化-通化市第二人民医院`,`延边-延边大学附属医院`,`长春-吉林大学第二医院`,`长春-吉林大学第三医院`,`长春-吉林大学第四医院`,`长春-吉林大学第一医院`,`长春-吉林大学口腔医院`,`长春-吉林大学中日联谊医院`,`长春-吉林省妇幼保健院`,`长春-吉林省肝胆病医院`,`长春-吉林省人民医院`,`长春-吉林省中医院`,`长春-吉林省肿瘤医院`,`长春-长春市儿童医院`,`长春-长春市妇产医院`,`长春-长春市中心医院`,`长春-长春市中医院`,`长春-长春市中医院骨伤矫形医院`,`长春-长春中医学院附属医院`,`长春-中国人民解放军第208医院`,`常州-常州市第二人民医院`,`常州-常州市第三人民医院`,`常州-常州市第一人民医院`,`常州-常州市中医院`,`常州-中国人民解放军第102医院`,`淮安-淮安市第二人民医院`,`淮安-淮安市第一人民医院`,`淮安-淮安市妇幼保健院`,`连云港-连云港市第一人民医院`,`连云港-连云港市妇幼保健院`,`连云港-连云港市中医院`,`南京-东南大学附属中大医院`,`南京-江苏大学附属医院`,`南京-江苏省妇幼保健院`,`南京-江苏省口腔医院`,`南京-江苏省人民医院`,`南京-江苏省苏北人民医院`,`南京-江苏省中西医结合医院`,`南京-江苏省中医院`,`南京-江苏省肿瘤医院`,`南京-南京军区南京总医院`,`南京-南京脑科医院`,`南京-南京市第二医院`,`南京-南京市第一医院`,`南京-南京市儿童医院`,`南京-南京市妇幼保健院`,`南京-南京市口腔医院`,`南京-南京市胸科医院`,`南京-南京市中医院`,`南京-南京医科大学第二附属医院`,`南京-南京总医院`,`南京-中国人民解放军第81医院`,`南京-中国医学科学院皮肤病医院`,`南通-南通大学附属医院`,`南通-南通市第三人民医院`,`南通-南通市第一人民医院`,`南通-南通市中医院`,`南通-南通市肿瘤医院`,`苏州-苏州大学附属第二医院`,`苏州-苏州大学附属第一医院`,`苏州-苏州大学附属儿童医院`,`苏州-苏州市立医院`,`苏州-苏州市中医院`,`泰州-泰州市人民医院`,`泰州-泰州中医院`,`无锡-无锡市第二人民医院`,`无锡-无锡市第四人民医院`,`无锡-无锡市妇幼保健院`,`无锡-无锡市精神卫生中心`,`无锡-无锡市人民医院`,`徐州-徐州市中心医院`,`徐州-徐州医学院附属医院`,`徐州-徐州中医院`,`盐城-盐城市第一人民医院`,`盐城-盐城市妇幼保健院`,`扬州-扬州大学附属医院`,`扬州-扬州市第一人民医院`,`扬州-扬州市妇幼保健院`,`镇江-镇江市第四人民医院`,`镇江-镇江市第一人民医院`,`抚州-抚州市第一人民医院`,`赣州-赣南医学院第一附属医院`,`赣州-赣州市妇幼保健院`,`赣州-赣州市立医院`,`赣州-赣州市人民医院`,`赣州-赣州市肿瘤医院`,`吉安-吉安市第三人民医院`,`吉安-吉安市中心人民医院`,`吉安-井冈山大学附属医院`,`江西-江西省胸科医院`,`江西-江西省肿瘤医院`,`景德镇-景德镇市第二人民医院`,`景德镇-景德镇市第三人民医院`,`景德镇-景德镇市第一人民医院`,`九江-九江市第三人民医院`,`九江-九江市第五人民医院`,`九江-九江市第一人民医院`,`九江-九江学院附属医院`,`南昌-江西省儿童医院`,`南昌-江西省肺科医院`,`南昌-江西省精神病院`,`南昌-江西省皮肤病专科医院`,`南昌-江西省人民医院`,`南昌-江西中医药大学附属医院`,`南昌-南昌大学第二附属医院`,`南昌-南昌大学第三附属医院`,`南昌-南昌大学第四附属医院`,`南昌-南昌大学第一附属医院`,`南昌-南昌大学附属口腔医院`,`南昌-南昌市第九医院`,`南昌-南昌市第三医院`,`南昌-南昌市第一医院`,`萍乡-萍乡市人民医院`,`上饶-上饶市第五人民医院`,`上饶-上饶市人民医院`,`上饶-上饶市肿瘤医院`,`新余-新余市人民医院`,`宜春-宜春市人民医院`,`鹰潭-鹰潭市人民医院`,`鞍山-鞍山钢铁集团公司总医院`,`鞍山-鞍山市中心医院`,`鞍山-鞍山市中医院`,`本溪-本溪钢铁（集团）公司总医院`,`本溪-本溪矿务局总医院`,`本溪-本溪市中心医院`,`朝阳-朝阳市中心医院`,`大连-大连大学附属新华医院`,`大连-大连大学附属中山医院`,`大连-大连大学医学院附属医院`,`大连-大连市第二人民医院`,`大连-大连市第六人民医院`,`大连-大连市第七人民医院`,`大连-大连市第三人民医院`,`大连-大连市儿童医院`,`大连-大连市妇女儿童医疗中心`,`大连-大连市金州区第一人民医院`,`大连-大连市友谊医院`,`大连-大连市中心医院`,`大连-大连市中医医院`,`大连-大连医科大学附属第二医院`,`大连-大连医科大学附属第一医院`,`丹东-丹东市第一医院`,`丹东-丹东市中心医院`,`抚顺-抚顺市第二医院`,`抚顺-抚顺市矿务局总医院`,`抚顺-抚顺市中心医院`,`抚顺-抚顺市中医院`,`阜新-阜新矿业集团有限责任公司总医院`,`阜新-阜新市中心医院`,`葫芦岛-葫芦岛市中心医院`,`锦州-锦州市中心医院`,`锦州-锦州铁路中心医院`,`锦州-锦州医科大学附属第一医院`,`锦州-辽宁医学院附属第一医院`,`辽阳-辽阳市中心医院`,`盘锦-盘锦辽河油田总医院`,`盘锦-盘锦市第二人民医院`,`沈阳-辽宁省金秋医院`,`沈阳-辽宁省人民医院`,`沈阳-辽宁省肿瘤医院`,`沈阳-辽宁中医药大学附属医院`,`沈阳-沈阳二四二医院`,`沈阳-沈阳军区总医院`,`沈阳-沈阳市第四人民医院`,`沈阳-沈阳市第五人民医院`,`沈阳-沈阳市儿童医院`,`沈阳-沈阳市妇儿医疗保健中心`,`沈阳-沈阳市红十字会医院`,`沈阳-沈阳医学院附属第二医院`,`沈阳-沈阳医学院附属中心医院`,`沈阳-沈阳医学院沈洲医院`,`沈阳-中国人民解放军第202医院`,`沈阳-中国人民解放军第463医院`,`沈阳-中国医科大学附属第四医院`,`沈阳-中国医科大学附属第一医院`,`沈阳-中国医科大学附属盛京医院`,`调兵山-铁法煤业（集团）总医院`,`铁岭-铁岭市中心医院`,`营口-营口市中心医院`,`包头-包头市中心医院`,`包头-内蒙古包钢医院`,`包头-内蒙古科技大学包头医学院第一附属医院`,`包头-内蒙古科技大学第三附属医院`,`赤峰-赤峰市医院`,`鄂尔多斯-鄂尔多斯市中心医院`,`呼和浩特-呼和浩特市第一医院`,`呼和浩特-内蒙古医科大学第二附属医院`,`呼和浩特-内蒙古医科大学附属医院`,`呼和浩特-内蒙古自治区妇幼保健院`,`呼和浩特-内蒙古自治区国际蒙医医院`,`呼和浩特-内蒙古自治区人民医院`,`呼和浩特-内蒙古自治区中医医院`,`呼和浩特-内蒙古自治区肿瘤医院`,`呼和浩特-中国人民解放军第253医院`,`呼伦贝尔-内蒙古林业总医院`,`通辽-内蒙古民族大学附属医院`,`固原-固原市人民医院`,`石嘴山-石嘴山第一人民医院`,`银川-宁夏回族自治区人民医院`,`银川-宁夏医科大学总医院`,`银川-银川市第一人民医院`,`银川-银川市口腔医院`,`西宁-青海大学附属医院`,`西宁-青海红十字医院`,`西宁-青海省藏医院`,`西宁-青海省第三人民医院`,`西宁-青海省第四人民医院`,`西宁-青海省妇女儿童医院`,`西宁-青海省人民医院`,`西宁-青海省心脑血管病专科医院`,`西宁-青海省中医院`,`西宁-西宁市第一人民医院`,`滨州-滨州医学院附属医院`,`德州-德州市人民医院`,`东营-胜利油田中心医院`,`菏泽-菏泽市立医院`,`济南-济南军区总医院`,`济南-济南市第四人民医院`,`济南-济南市妇幼保健院`,`济南-济南市中心医院`,`济南-济南市中医院`,`济南-山东大学第二医院`,`济南-山东大学口腔医院`,`济南-山东大学齐鲁儿童医院`,`济南-山东大学齐鲁医院`,`济南-山东省立医院`,`济南-山东省千佛山医院`,`济南-山东省肿瘤医院`,`济南-山东中医药大学第二附属医院`,`济南-山东中医药大学附属医院`,`济南-中国人民解放军济南军区第四五六医院`,`济宁-济宁市第一人民医院`,`济宁-济宁市中医院`,`济宁-济宁医学院附属医院`,`莱芜-莱芜市妇幼保健院`,`聊城-聊城市人民医院`,`聊城-聊城市中医院`,`临沂-临沂市妇幼保健院`,`临沂-临沂市人民医院`,`临沂-临沂市中医院`,`青岛-青岛大学附属医院`,`青岛-青岛大学医学院附属心血管病医院`,`青岛-青岛市第五人民医院`,`青岛-青岛市妇女儿童医院 `,`青岛-青岛市海慈医疗集团`,`青岛-青岛市人民医院`,`青岛-青岛市市立医院`,`青岛-青岛市中心医院`,`青岛-山东省青岛疗养院`,`青岛-中国人民解放军海军第401医院`,`日照-日照市人民医院`,`泰安-肥城中医院`,`泰安-泰安市中心医院`,`泰安-泰山医学院附属医院`,`威海-威海市中心医院`,`威海-威海市中医院`,`威海-文登中心医院`,`潍坊-潍坊市人民医院`,`潍坊-潍坊市中医院`,`潍坊-潍坊医学院附属医院`,`烟台-烟台口腔医院`,`烟台-烟台市中医院`,`烟台-烟台毓璜顶医院`,`枣庄-枣庄市立医院`,`淄博-山东中医药大学第四附属医院`,`淄博-淄博市妇幼保健院`,`淄博-淄博市中心医院`,`大同-大同煤矿集团有限责任公司总医院`,`大同-大同市第三人民医院`,`大同-大同市第五人民医院`,`汾阳-山西省汾阳医院`,`晋城-山西晋城无烟煤矿业集团有限责任公司总医院`,`晋城-山西省晋城市人民医院`,`晋中-晋中市第一人民医院`,`晋中-山西省荣军精神康宁医院`,`临汾-临汾市第四人民医院`,`临汾-临汾市人民医院`,`吕梁-吕梁市人民医院`,`太原-山西红十字口腔医院`,`太原-山西省儿童医院`,`太原-山西省人民医院`,`太原-山西省太原精神病医院`,`太原-山西省西山矿务职工总医院`,`太原-山西省心血管病医院`,`太原-山西省眼科医院`,`太原-山西省职业病医院`,`太原-山西省中西医结合医院`,`太原-山西省中医学院附属医院`,`太原-山西省中医院`,`太原-山西省肿瘤医院`,`太原-山西医科大学第二医院 `,`太原-山西医科大学第一医院 `,`太原-太原钢铁(集团)有限公司总医院`,`太原-太原市第三人民医院`,`太原-太原市第四人民医院`,`太原-太原市妇幼保健院`,`太原-太原市中心医院`,`忻州-忻州市人民医院`,`阳泉-阳泉煤业(集团)有限责任公司总医院`,`阳泉-阳泉市第一人民医院`,`运城-山西省运城市中心医院`,`长治-山西潞安矿业(集团)有限责任公司总医院`,`长治-山西省长治市人民医院`,`长治-长治医学院附属和济医院`,`长治-长治医学院附属和平医院`,`安康-安康市中心医院`,`宝鸡-宝鸡市妇幼保健院`,`宝鸡-宝鸡市人民医院`,`宝鸡-宝鸡市中心医院`,`宝鸡-宝鸡市中医院`,`汉中-汉中市人民医院`,`汉中-汉中市中心医院`,`汉中-三二○一医院`,`渭南-渭南市中心医院`,`西安-陕西省第三人民医院`,`西安-陕西省妇幼保健院`,`西安-陕西省结核病防治院`,`西安-陕西省精神卫生中心`,`西安-陕西省人民医院`,`西安-陕西省中医药研究院附属医院`,`西安-陕西省中医院`,`西安-武警陕西总队医院`,`西安-西安高新医院`,`西安-西安交通大学第二附属医院`,`西安-西安交通大学第一附属医院`,`西安-西安交通大学附属口腔医院`,`西安-西安市第八医院`,`西安-西安市第九医院`,`西安-西安市第四医院`,`西安-西安市第五医院`,`西安-西安市第一医院`,`西安-西安市儿童医院`,`西安-西安市红十字会医院`,`西安-西安市精卫中心`,`西安-西安市胸科医院`,`西安-西安市中心医院`,`西安-西安市中医院`,`西安-中国人民解放军第323医院`,`西安-中国人民解放军第451医院`,`西安-中国人民解放军第四军医大学口腔医院`,`西安-中国人民解放军第四军医大学唐都医院`,`西安-中国人民解放军第四军医大学西京医院`,`咸阳-陕西中医学院第二附属医院`,`咸阳-陕西中医学院附属医院`,`咸阳-咸阳市中心医院`,`咸阳-中铁二十局医院`,`延安-延安大学附属医院`,`延安-延安市中医院`,`榆林-榆林市北方医院`,`榆林-榆林市第二医院`,`榆林-榆林市第一医院`,`上海-第二军医大学附属东方肝胆外科医院`,`上海-复旦大学附属儿科医院`,`上海-复旦大学附属妇产科医院`,`上海-复旦大学附属华东医院`,`上海-复旦大学附属华山医院`,`上海-复旦大学附属眼耳鼻喉科医院`,`上海-复旦大学附属中山医院`,`上海-复旦大学附属肿瘤医院`,`上海-上海宝山区中西医结合医院`,`上海-上海第十人民医院`,`上海-上海光华中西医结合医院`,`上海-上海国际医学中心`,`上海-上海华东医院`,`上海-上海交通大学医学院附属第九人民医院`,`上海-上海交通大学医学院附属第三人民医院`,`上海-上海交通大学医学院附属仁济医院`,`上海-上海交通大学医学院附属瑞金医院`,`上海-上海交通大学医学院附属上海儿童医学中心`,`上海-上海交通大学医学院附属新华医院`,`上海-上海市第六人民医院`,`上海-上海市第七人民医院`,`上海-上海市第十人民医院`,`上海-上海市第一妇婴保健院`,`上海-上海市第一人民医院`,`上海-上海市东方医院`,`上海-上海市儿童医院`,`上海-上海市肺科医院 `,`上海-上海市公共卫生临床中心`,`上海-上海市黄浦区中西医结合医院`,`上海-上海市精神卫生中心`,`上海-上海市皮肤病医院`,`上海-上海市同济医院`,`上海-上海市胸科医院`,`上海-上海市眼病防治中心`,`上海-上海市质子重离子医院`,`上海-上海市中西医结合医院`,`上海-上海市中医医院`,`上海-上海同济大学附属口腔医院`,`上海-上海同济医院`,`上海-上海长海医院`,`上海-上海长征医院`,`上海-上海中医药大学附属龙华医院`,`上海-上海中医药大学附属曙光医院`,`上海-上海中医药大学附属岳阳中西医结合医院`,`上海-武警上海总队医院`,`上海-中国福利会国际和平妇幼保健院`,`上海-中国人民解放军第411医院`,`上海-中国人民解放军第455医院`,`上海-中国人民解放军第85医院`,`成都-成都大学附属医院`,`成都-成都军区空军机关医院`,`成都-成都军区总医院`,`成都-成都市第二人民医院`,`成都-成都市第三人民医院`,`成都-成都市第一人民医院`,`成都-成都市妇幼保健院`,`成都-成都医学院第一附属医院`,`成都-成都运动创伤研究所`,`成都-成都中医药大学附属医院`,`成都-四川大学华西第二医院`,`成都-四川大学华西第三医院`,`成都-四川大学华西口腔医院`,`成都-四川大学华西医院`,`成都-四川省妇幼保健院`,`成都-四川省骨科医院`,`成都-四川省人民医院`,`成都-四川省肿瘤医院`,`成都-中国人民解放军第452医院`,`成都-中国人民解放军第47医院`,`达州-达州市中西医结合医院`,`达州-达州市中心医院`,`德阳-德阳市人民医院`,`广安-广安市人民医院`,`广元-广元市第一人民医院`,`广元-广元市精神卫生中心`,`广元-广元市中心医院`,`广元-乐山市人民医院`,`乐山-乐山市中医院`,`凉山-凉山州第一人民医院`,`泸州-泸州医学院附属医院`,`绵阳-绵阳市第三人民医院`,`绵阳-绵阳市人民医院`,`绵阳-绵阳市中心医院`,`绵阳-绵阳市中医院`,`绵阳-四川绵阳404医院`,`南充-川北医学院附属医院`,`南充-南充市中心医院`,`内江-内江市第二人民医院`,`内江-内江市第一人民医院`,`内江-内江市中医医院`,`攀枝花-攀枝花第三人民医院`,`攀枝花-攀枝花钢铁有限责任公司职工总医院`,`攀枝花-攀枝花市妇幼保健院`,`攀枝花-攀枝花市中西医结合医院`,`攀枝花-攀枝花市中心医院`,`遂宁-遂宁市中心医院`,`雅安-雅安市人民医院`,`宜宾-宜宾市第二人民医院`,`宜宾-宜宾市第一人民医院`,`自贡-自贡市第四人民医院`,`自贡-自贡市第一人民医院`,`自贡-自贡市精神卫生中心`,`天津-北辰区中医医院`,`天津-泰达国际心血管病医院`,`天津-天津第四中心医院`,`天津-天津市安定医院`,`天津-天津市宝坻区人民医院`,`天津-天津市传染病医院`,`天津-天津市大港医院`,`天津-天津市第二人民医院`,`天津-天津市第三医院`,`天津-天津市第三中心医院`,`天津-天津市第四中心医院`,`天津-天津市第五中医医院`,`天津-天津市第一中心医院`,`天津-天津市儿童医院`,`天津-天津市肺科医院`,`天津-天津市公安局安康医院`,`天津-天津市环湖医院`,`天津-天津市口腔医院`,`天津-天津市人民医院`,`天津-天津市人民医院滨江分院`,`天津-天津市天津医院`,`天津-天津市心理卫生专科医院`,`天津-天津市胸科医院`,`天津-天津市眼科医院`,`天津-天津市长征医院`,`天津-天津市中西医结合医院`,`天津-天津市中心妇产科医院`,`天津-天津市中医药研究院附属医院`,`天津-天津市中医医院`,`天津-天津市肿瘤医院`,`天津-天津医科大学第二附属医院`,`天津-天津医科大学第三附属医院`,`天津-天津医科大学附属肿瘤医院`,`天津-天津医科大学口腔医院`,`天津-天津医科大学肿瘤医院`,`天津-天津医科大学总医院`,`天津-天津中西医结合医院`,`天津-天津中医药大学第二附属医院`,`天津-天津中医药大学第一附属医院`,`天津-武警天津总队医院`,`天津-武警医学院附属医院`,`天津-武清区中医院`,`天津-中国人民解放军第254医院`,`天津-中国人民解放军第464医院`,`天津-中国医学科学院血液病医院`,`拉萨-拉萨市人民医院`,`拉萨-西藏军区总医院`,`拉萨-西藏自治区人民医院`,`克拉玛依-克拉玛依市中心医院`,`乌鲁木齐-兰州军区乌鲁木齐总医院`,`乌鲁木齐-乌鲁木齐市友谊医院`,`乌鲁木齐-乌鲁木齐铁路中心医院`,`乌鲁木齐-新疆生产建设兵团总医院`,`乌鲁木齐-新疆石油管理局乌鲁木齐医院`,`乌鲁木齐-新疆维吾尔自治区人民医院`,`乌鲁木齐-新疆维吾尔自治区维吾尔医医院`,`乌鲁木齐-新疆医科大学第二附属医院`,`乌鲁木齐-新疆医科大学第五附属医院`,`乌鲁木齐-新疆医科大学第一附属医院`,`乌鲁木齐-新疆医科大学附属肿瘤医院`,`乌鲁木齐-新疆自治区肺科医院`,`乌鲁木齐-新疆自治区人民医院`,`乌鲁木齐-新疆自治区中医院`,`乌鲁木齐-中国人民解放军第474医院`,`伊宁-伊犁哈萨克自治州友谊医院`,`楚雄-楚雄州人民医院`,`大理-大理州人民医院`,`昆明-成都军区昆明总医院`,`昆明-昆明市第四人民医院`,`昆明-昆明市第一人民医院`,`昆明-昆明市延安医院`,`昆明-昆明市中医院`,`昆明-昆明医科大学第二附属医院`,`昆明-昆明医科大学第一附属医院`,`昆明-云南省第二人民医院`,`昆明-云南省第一人民医院`,`昆明-云南省中医院`,`昆明-云南中医学院附属医院`,`曲靖-曲靖市第一人民医院`,`西双版纳-西双版纳州人民医院`,`玉溪-玉溪市人民医院`,`玉溪-玉溪市中医医院`,`昭通-昭通市中医院`,`杭州-杭州口腔医院`,`杭州-杭州市第七人民医院`,`杭州-杭州市第三人民医院`,`杭州-杭州市第一人民医院`,`杭州-杭州市红十字会医院`,`杭州-杭州市西溪医院`,`杭州-杭州市中医院`,`杭州-浙江大学医学院附属第一医院`,`杭州-浙江大学医学院附属儿童医院`,`杭州-浙江大学医学院附属妇产科医院`,`杭州-浙江大学医学院附属口腔医院`,`杭州-浙江大学医学院附属邵逸夫医院`,`杭州-浙江省口腔医院`,`杭州-浙江省立同德医院`,`杭州-浙江省人民医院`,`杭州-浙江省中医院`,`杭州-浙江省肿瘤医院`,`杭州-浙江医院`,`杭州-中国人民解放军第一一七医院`,`湖州-湖州市第三人民医院`,`湖州-湖州市中心医院`,`嘉兴-嘉兴市第一医院`,`嘉兴-嘉兴市妇幼保健院`,`嘉兴-武警浙江省总队医院`,`金华-金华市中心医院`,`金华-浙江大学医学院附属第四医院`,`金华-浙江中医学院附属第三医院`,`丽水-丽水市人民医院`,`丽水-丽水市中心医院`,`临海-浙江省台州医院`,`宁波-宁波大学医学院附属医院`,`宁波-宁波市第二医院`,`宁波-宁波市第六医院`,`宁波-宁波市第一医院`,`宁波-宁波市妇女儿童医院`,`宁波-宁波市医疗中心李惠利医院`,`宁波-宁波市中医院`,`绍兴-绍兴市妇幼保健院`,`绍兴-绍兴市人民医院`,`绍兴-绍兴市中医院`,`台州-台州市中心医院`,`台州-台州中心医院`,`台州-温岭中医院`,`温州-温州市第二人民医院`,`温州-温州市中心医院`,`温州-温州医科大学附属第二医院`,`温州-温州医科大学附属第一医院`,`温州-温州医学院附属眼视光医院`,`舟山-舟山市中医院`,`重庆-九龙坡中医院`,`重庆-陆军军医大学第二附属医院`,`重庆-陆军军医大学第三附属医院`,`重庆-陆军军医大学第一附属医院`,`重庆-黔江市中心医院`,`重庆-武警重庆总队医院`,`重庆-中国人民解放军第324医院`,`重庆-重庆市第八人民医院`,`重庆-重庆市第九人民医院`,`重庆-重庆市第三人民医院`,`重庆-重庆市第四人民医院`,`重庆-重庆市第五人民医院`,`重庆-重庆市第一人民医院`,`重庆-重庆市涪陵中心医院`,`重庆-重庆市妇幼保健院`,`重庆-重庆市红十字会医院`,`重庆-重庆市三峡妇女儿童医院`,`重庆-重庆市三峡中心医院`,`重庆-重庆市胸科医院`,`重庆-重庆市中山医院`,`重庆-重庆市中医研究所`,`重庆-重庆市中医院`,`重庆-重庆市肿瘤医院`,`重庆-重庆医科大学附属第二医院`,`重庆-重庆医科大学附属第一医院`,`重庆-重庆医科大学附属儿童医院`,`重庆-重庆医科大学附属口腔医院`,`重庆-重庆医科大学附属永川医院`],
        hostPublic:[
            '广州市荔湾区骨伤科医院',
            '广州市龙洞人民医院',
            '广州新市医院',
            '广州市正骨医院',
            '广州市海珠区滨江街社区卫生服务中心',
            '广州市海珠区瑞宝街社区卫生服务中心',
            '广州市荔湾区人民医院',
            '广州市荔湾区芳村中医医院',
            '广州市荔湾区妇幼保健院',
            '广州市白云区第二人民医院',
            '北京联合大学中医药学院附属医院（北京鼓楼中医院）',
            '北京市朝阳区中医院',
            '北京市垂杨柳医院〓北京微创医院',
            '北京市第二医院(北京市西城区老年医院)',
            '北京市二龙路医院（北京市肛肠医院）',
            '北京市丰台区丰台医院',
            '北京市丰台区妇幼保健院',
            '北京市海淀区妇幼保健院',
            '北京市海淀医院',
            '北京市和平里医院',
            '北京市回民医院',
            '北京市隆福医院',
            '北京市普仁医院',
            '北京市中关村医院',
            '北京市中西医结合医院〓北京中医药大学附属中西医结合医院',
            '北京水利医院',
            '北京中医药大学第三附属医院(北京冶金医院)',
            '航空总医院',
            '中国人民解放军三一六医院',
            '空军指挥学院医院',
            '复旦大学附属中山医院分部',
            '上海长征医院闸北分院〓上海市闸北区中心医院',
            '上海电力医院',
            '上海光华医院〓上海市长宁区光华中西医结合医院',
            '上海建工医院',
            '上海交通大学医学院附属瑞金医院卢湾分院',
            '上海浦东新区人民医院',
            '上海市宝山区大场医院',
            '上海市长宁区妇幼保健院',
            '上海市长宁区天山中医院',
            '上海市长宁区同仁医院',
            '上海市第八人民医院',
            '上海市第七人民医院',
            '上海市第一人民医院分院(原上海市第四人民医院)',
            '上海市虹口区妇幼保健院',
            '上海市黄博区中心医院分部(原上海市黄浦区中医院)',
            '上海市黄浦区中西医结合医院',
            '上海市黄浦区中心医院',
            '上海市嘉定区中医医院',
            '上海市静安区中心医院',
            '上海市浦东新区公利医院',
            '上海市普陀区利群医院',
            '上海市普陀区人民医院',
            '上海市普陀区中心医院',
            '上海市徐汇区中心医院',
            '上海市杨浦区中心医院',
            '上海市中西医结合医院',
            '中国人民武装警察部队上海总队医院',
            '上海市红房子妇科医院 (杨浦院区)',
            '杭州市第四人民医院〓杭州市肿瘤医院',
            '杭州市妇幼保健院',
            '杭州市江干区人民医院',
            '杭州市口腔医院',
            '浙江大学医学院附属第一医院分院(原杭州铁路医院)',
            '浙江中医药大学附属第三医院',
            '长沙市第四医院〓长沙市中西医结合医院',
            '长沙市妇幼保健院',
            '长沙市口腔医院',
            '长沙市中心医院(原长沙市第五医院)',
            '湖南省结核病医院',
            '湖南省军区医院',
            '广东江南医院',
            '广东省工人医院(广东省第二工人医院)',
            '广东省电力一局医院',
            '广东省荣誉军人康复医院',
            '广州市天河区红十字会医院',
            '广东药学院广钢附属医院(原广州钢铁企业集团医院)',
            '广州市白云区第一人民医院(原广州市白云区红十字会医院)',
            '广州市白云区人民医院',
            '中山大学附属第六医院（中山大学附属胃肠肛门医院）',
            '广州市东山区妇幼保健院',
            '广州市越秀区第二中医医院（广州市东山区中医院）',
            '广州市番禺区大岗人民医院',
            '广州市番禺区妇幼保健院〓广州市番禺区何贤纪念医院',
            '广州市芳村区妇幼保健院',
            '广州市芳村区中医院',
            '广州市海珠区第一人民医院',
            '广州市海珠区妇幼保健院',
            '广州市海珠区中医院',
            '广州市黄埔区中医院',
            '广州市荔湾区中心医院〓广州医学院荔湾医院',
            '广州市天河区妇幼保健院',
            '广州市天河区中医医院',
            '广州市越秀区中医医院(广州市越秀区第一人民医院)',
            '广州市越秀区妇幼保健院',
            '广州市越秀区正骨医院',
            '广州新海医院(原广州海员医院)',
            '暨南大学医学院第一附属医院东圃分院',
            '南方医科大学中西医结合医院',
            '兵器工业卫生研究所(原兵器工业五二一医院)',
            '民航西安医院',
            '陕西省康复医院（陕西博爱医院)',
            '陕西地质矿产局职工医院',
            '陕西省第四人民医院（陕西省建材医院）',
            '陕西省交通医院',
            '西安医学院附属医院（原西安军工医院）',
            '西安市东郊第二职工医院',
            '西安尚德医院',
            '西安市碑林区红十字会医院',
            '西安市创伤医院',
            '西安市第二医院〓西安市肿瘤医院',
            '西安市第六医院',
            '西安市第十医院〓西安市精神卫生中心',
            '西安市东方医院',
            '西安市东郊第三职工医院',
            '西安市东郊第一职工医院',
            '西安市妇幼保健院',
            '西安市华山中心医院',
            '西安市莲湖区红十字会医院',
            '西安市未央区中医院',
            '西安市新城区中医院',
            '西安铁路医院',
            '西安西郊纺织医院',
            '西安冶金医院',
            '北京市崇文区第一人民医院',
            '北京市丰台区南苑医院',
            '北京市丰台区铁营医院（丰台区铁营社区卫生服务中心、丰台区西罗园社区卫生服务中心）',
            '北京市宣武区广外医院',
            '上海市虹口区江湾医院',
            '上海长航医院',
            '上海市沪东造船集团职工医院',
            '上海市浦东新区南华医院',
            '上海市浦东新区妇幼保健院',
            '上海市浦东新区浦南医院',
            '上海市浦东新区中医医院',
            '上海市曲阳医院',
            '上海市徐汇区大华医院',
            '上海市徐汇区枫林街道社区卫生服务中心（宛平地段医院）',
            '上海市杨浦区控江医院〓上海市杨浦区控江红十字医院',
            '上海市杨浦区中医医院',
            '上海市中冶职工医院',
            '广州亿仁医院(原广州石化医院)',
            '西安市灞桥区人民医院',
            '西安市长安区中医院',
            '西安市第三医院',
            '西安市口腔医院',
            '西安市莲湖区中医院',
            '西安市未央区第二人民医院',
            '西安市未央区第一人民医院',
            '航天中心医院(原721医院)（又名中国航天工业总公司中心医院）',
            '南京医科大学附属口腔医院〓江苏省口腔医院',
            '中国医学科学院皮肤病医院',
            '湖南旺旺医院',
            '广州军区广州总医院',
            '南方医科大学第三附属医院（广州邮电医院）',
            '广州中医药大学第三附属医院（广州中医药大学附属骨伤科医院）',
            '南方医科大学南方医院',
            '南方医科大学珠江医院',
            '中国人民解放军第四二一医院',
            '中国人民解放军第四五八医院',
            '中国人民解放军广州军区一五七中心医院',
            '广东省皮肤病医院',
            '北京大学第三医院',
            '北京大学第一医院（北京大学北大医院）',
            '北京大学人民医院',
            '首都医科大学附属北京妇产医院（北京妇幼保健院）',
            '北京积水潭医院',
            '北京中日友好医院',
            '北京中医药大学东直门医院',
            '北京中医医院',
            '海军总医院',
            '中国人民解放军总医院第二附属医院（309医院）',
            '空军总医院',
            '首都儿科研究所附属儿童医院',
            '首都医科大学附属北京安贞医院',
            '首都医科大学附属北京儿童医院',
            '首都医科大学附属北京口腔医院',
            '首都医科大学附属北京天坛医院',
            '首都医科大学附属北京同仁医院（包括南区医院）',
            '首都医科大学附属复兴医院',
            '首都医科大学宣武医院',
            '卫生部北京医院',
            '武警北京市总队第二医院',
            '武警北京市总队医院',
            '武警北京总队第三医院',
            '中国人民解放军第三0六医院',
            '中国人民解放军第三0五医院',
            '中国人民解放军空军航空医学研究所附属医院',
            '中国人民解放军三0七医院（307）',
            '中国人民解放军总医院',
            '中国医学科学院北京协和医院',
            '中国医学科学院阜外医院 ',
            '中国医学科学院肿瘤医院肿瘤研究所',
            '中国中医科学院广安门医院',
            '北京协和医院西院〓北京邮电医院',
            '复旦大学附属中山医院',
            '复旦大学附属肿瘤医院',
            '上海第二军医大学附属东方肝胆外科医院',
            '上海交通大学医学院附属仁济医院（包括东院、西院、南院、北院）',
            '上海交通大学医学院附属上海儿童医学中心',
            '上海伽玛刀医院',
            '上海华东医院',
            '上海交通大学医学院附属新华医院',
            '上海交通大学医学院附属第九人民医院',
            '上海交通大学医学院附属瑞金医院',
            '上海市第二军医大学附属长海医院',
            '上海市第二军医大学附属长征医院',
            '上海市第六人民医院',
            '上海市第十人民医院',
            '上海市第一妇婴保健院',
            '上海市第一人民医院',
            '上海市儿童医院',
            '上海市肺科医院',
            '上海市口腔病防治院',
            '上海市皮肤病性病医院',
            '上海市中医院',
            '上海胸科医院',
            '上海中医药大学附属龙华医院',
            '上海中医药大学附属曙光医院',
            '同济大学附属口腔医院',
            '上海市同济医院',
            '上海中医药大学附属岳阳中西医结合医院',
            '中国福利会国际和平妇幼保健院',
            '中国人民解放军第八五医院',
            '中国人民解放军第四五五医院',
            '中国人民解放军第四一一医院',
            '东南大学附属中大医院',
            '江苏省人民医院',
            '江苏省中医药研究院〓江苏省中西医结合医院',
            '江苏省肿瘤医院',
            '解放军第四五四医院〓南京市君协医院',
            '南京军区南京总医院',
            '南京市第一医院',
            '南京市儿童医院',
            '南京市妇幼保健医院',
            '南京市鼓楼医院',
            '南京市脑科医院',
            '南京市胸科医院',
            '南京医科大学第二附属医院〓南京医科大学附属儿童医院〓江苏省第二红十字医院',
            '南京中医药大学第二附属医院',
            '南京中医药大学第三附属医院（南京市中医院）',
            '中国人民解放军第八一医院',
            '杭州市西溪医院（杭州市第六人民医院）=杭州市传染病医院',
            '杭州市第一人民医院',
            '浙江大学医学院附属儿童医院',
            '浙江大学医学院附属口腔医院',
            '浙江大学医学院附属邵逸夫医院',
            '浙江省立同德医院',
            '浙江省人民医院',
            '杭州市红十字会医院〓浙江省中西医结合医院',
            '浙江省中医医院',
            '浙江医院',
            '中国人民解放军第一一七医院',
            '湖南省第二人民医院〓湖南省脑科医院',
            '湖南省儿童医院',
            '湖南省妇幼保健院',
            '湖南省人民医院',
            '湖南省中医药研究院附属医院',
            '湖南省肿瘤医院',
            '湖南中医药大学第二附属医院',
            '湖南中医药大学第一附属医院',
            '中国人民解放军第一六三医院',
            '中南大学湘雅二医院',
            '中南大学湘雅三医院',
            '中南大学湘雅医院',
            '广东省第二中医院',
            '广东省妇幼保健院',
            '广东省口腔医院',
            '广东省人民医院',
            '广东省中医院二沙岛分院',
            '广东药学院附属第一医院(原广州铁路中心医院)',
            '广州市第八人民医院(原广州市传染病医院)',
            '广州市第二人民医院=广州医科大学第三附属医院',
            '广州市第十二人民医院〓广州市职业病医院',
            '广州市妇女儿童医疗中心（广州市儿童医院）',
            '广州市红十字会医院',
            '广州市精神病医院',
            '广州市胸科医院',
            '越秀区六榕街社区卫生服务中心（广州市越秀区第二人民医院）',
            '广州市中医院',
            '广州医科大学附属第二医院',
            '广州医科大学附属第一医院',
            '广州医学院附属广州市第一人民医院',
            '广州中医药大学第二附属医院（广东省中医院）',
            '广州中医药大学第一附属医院',
            '暨南大学医学院第一附属医院（广州华侨医院）',
            '中国人民武装警察部队广东省总队医院',
            '中山大学附属第二医院（中山大学孙逸仙纪念医院）',
            '中山大学附属第三医院',
            '中山大学附属第一医院',
            '中山大学附属第一医院黄埔院区',
            '中山大学附属口腔医院',
            '中山大学中山眼科中心（中山大学附属眼科医院）',
            '中山大学肿瘤医院',
            '广东省中医院大学城医院',
            '第四军医大学口腔医院',
            '第四军医大学唐都医院',
            '第四军医大学西京医院',
            '陕西省妇幼保健院',
            '西安长安医院',
            '西安市第四医院',
            '西安市第五医院〓西安市风湿病医院',
            '西安市第一医院',
            '西安市儿童医院(西安交通大学医学院附属儿童医院)',
            '西安市红十字会医院',
            '西安市中心医院',
            '西安市中医院',
            '西安市第九医院（西安市铁路中心医院）',
            '中国人民解放军第三二三医院',
            '中国人民解放军空军四五一医院',
            '中医药研究院附属医院（陕西省中医医院）',
            '北京市宣武区中医医院',
            '北京电力医院',
            '煤炭工业部总医院',
            '清华大学第一附属医院〓北京华信医院(原酒仙桥医院)',
            '中国人民解放军二六一医院',
            '中国中医科学院望京医院',
            '南京市口腔医院〓南京大学医学院附属口腔医院',
            '南京市中西医结合医院〓南京市钟山医院',
            '杭州师范大学附属医院（杭州市第二人民医院）',
            '长沙市第三医院',
            '陕西省辅仁医院（西安医学院第二附属医院）',
            '中国西电集团医院',
            '上海市普陀区妇婴保健院',
            '西安市第七医院(原西安市结核病、胸部肿瘤医院)',
            '北京大学口腔医院',
            '北京大学临床肿瘤医院（北京肿瘤医院）',
            '中国中医科学院西苑医院',
            '广东省第二人民医院(原广东省一七七医院)',
            '长沙市第一医院',
            '上海市浦东新区东方医院〓同济大学附属东方医院',
            '浙江大学医学院附属妇产科医院',
            '西安市北方医院',
            '北京大学第一医院肿瘤诊所中心(原交通部北京交通医院)',
            '北京道培医院',
            '北京市监狱管理局清河分局医院',
            '北京市石景山区中医院〓北京市石景山区八角医院',
            '北京市宣武区结核病防治所',
            '北京按摩医院',
            '中国藏学研究中心北京藏医院',
            '南京东南眼科医院',
            '南京紫金医院',
            '湖南省荣军医院',
            '广州南洋肿瘤医院',
            '广州市番禺区岐山医院（精神病院）',
            '广州市越秀区儿童医院',
            '广州文明微创医院',
            '广州协佳泌尿科医院',
            '广州女子医院',
            '广州市越秀区人民医院',
            '广州市越秀区诗书街社区卫生服务中心',
            '广州糖尿病医院',
            '南方医科大学江都医院',
            '广州市第十二人民医院广园分院',
            '广州博爱医院',
            '广州市萝岗区中医医院',
            '广州市番禺区第二人民医院',
            '北京大学医院',
            '北京市博仁医院(原北京市滨河医院)',
            '北京市朝阳区妇幼保健院〓北京现代女子医院',
            '北京市崇文区妇幼保健院(原崇文区儿童医院)',
            '北京市第六医院',
            '北京市东四妇产医院（北京市东城区妇幼保健院）',
            '北京市房山区妇幼保健院',
            '北京市房山区燕山妇幼保健院',
            '北京市房山区中医医院',
            '北京市房山区中医院',
            '北京市海淀区精神卫生防治院（青龙桥社区卫生服务中心）',
            '北京市化工职业病防治院',
            '北京市惠新医院',
            '北京市健宫医院(原北京建工医院)',
            '北京市社会福利医院（北京市海淀区清河街道社会福利社区卫生服务中心）',
            '北京市石景山医院',
            '北京市丰盛中医骨伤专科医院（北京市西城区丰盛医院，北京市西城区金融街社区卫生服务中心）',
            '北京市西城区平安医院',
            '北京市展览路医院',
            '北京万杰医院',
            '北京丰台右安门医院',
            '中国人民解放军北京军医学院医院',
            '首都国际机场医院',
            '中国人民解放军66400部队医院',
            '中国中医科学院眼科医院',
            '北京市监狱管理局中心医院',
            '北京国济中医医院',
            '复旦大学附属上海市第五人民医院',
            '复旦大学附属中山医院分院',
            '公用事业职工医院〓上海公费医院',
            '上海第一精神病康复院',
            '上海市第一人民医院宝山分院(原上海市宝山区吴淞中心医院)',
            '上海海港医院',
            '上海申东医院',
            '上海市宝山区中西医结合医院',
            '上海市宝山区妇幼保健所',
            '上海市北站医院',
            '上海市第二肺科医院',
            '上海市第二人民医院',
            '上海市东方乳腺疾病医院(华山医院分部)',
            '上海市东医院(原上海市纺织第二医院)',
            '上海市海员医院',
            '上海市虹口区精神卫生中心',
            '上海市嘉定区妇幼保健院',
            '上海市嘉定区中心医院',
            '上海市江湾医院',
            '上海市静安区老年医院',
            '上海市卢湾区东南医院',
            '上海市黄浦区妇幼保健院',
            '上海市南汇区光明中医医院',
            '上海市南市区精神病防治院',
            '上海市浦东新区精神卫生中心',
            '上海市普陀区中医医院',
            '上海市神州中医院',
            '上海市香山中医院',
            '上海市杨浦区安图医院',
            '杨浦区妇幼保健院',
            '上海市杨浦区中心医院中原分部',
            '上海市闸北区妇女保健所',
            '上海市闸北区中医院',
            '上海邮电医院',
            '黄浦区妇幼保健所',
            '金山区中西医结合医院',
            '江苏省省级机关医院〓江苏省老年医院',
            '南京市第三医院(原南京铁路分局中心医院)',
            '南京市鼓楼医院北院(原南京市第三医院)',
            '南京市建中中医院',
            '上海梅山冶金公司职工医院',
            '上海梅山医院',
            '中国人民武装警察部队江苏总队南京医院',
            '杭州市拱墅中西医结合医院',
            '杭州市西湖区人民医院',
            '杭州市萧山区第四人民医院',
            '杭州市余杭区妇幼保健院',
            '杭州市余杭区中医医院',
            '浙江省立同德医院分院',
            '浙江省青春医院〓浙江省监狱中心医院',
            '浙江医院分院(原杭州市第九人民医院)',
            '长沙市传染病院〓长沙市第六医院',
            '长沙市第八医院（长沙市中医院）',
            '长沙市精神病院〓长沙市第三社会福利院',
            '广东省司法警察医院',
            '广钢集团职工医院',
            '广州经济技术开发区医院',
            '广州市白云区中医院',
            '广州市东山区人民医院',
            '广州市番禺区人民医院（番禺中心医院）',
            '广州市芳村区第二人民医院',
            '广州市芳村区人民医院',
            '广州市海珠区第二人民医院',
            '广州市海珠区石溪中医院',
            '广州市花都区胡忠医院〓广州市花都区妇幼保健院',
            '广州市花都区人民医院',
            '广州市交运医院',
            '广州市荔湾区第二人民医院',
            '广州市荔湾区中医院',
            '广州市越秀区第二人民医院东风分院（越秀区东风街社区卫生服务中心）',
            '广州燕岭医院',
            '民航广州医院',
            '铁道部石门疗养院广州铁路石门精神疾病康复医院',
            '庆安集团有限公司职工医院',
            '西安市碑林区中医院',
            '西安市唐城医院',
            '西安马应龙肛肠医院（原西安肛肠医院）',
            '中美集团西安同济医院〓西安雁塔区中医院',
            '陕西航天医院',
            '北京市朝阳区第三医院(原朝阳区八里庄医院)',
            '北京市丰台区长辛店医院',
            '北京市石景山区妇幼保健院',
            '北京同仁堂崇文中医院',
            '清华大学校医院',
            '中国核工业北京四0一医院',
            '上海第三钢铁厂职工医院',
            '上海第一钢铁厂职工医院〓上海市宝山区一钢医院',
            '上海航道医院',
            '上海江南造船集团职工医院',
            '上海民航医院',
            '上海市民政第二精神卫生中心',
            '上海普陀区精神卫生中心',
            '上海市宝山区精神卫生中心',
            '上海市宝山区罗店医院',
            '上海市宝山区仁和医院',
            '上海市宝山区中医医院',
            '上海市长宁区精神卫生中心〓上海痴呆老年医院',
            '上海市黄浦区精神卫生中心',
            '上海市嘉定区安亭医院',
            '上海市嘉定区精神卫生中心',
            '上海市嘉定区南翔医院',
            '上海市静安区精神卫生中心',
            '上海市龙华浦东医院',
            '上海市民政第一精神卫生中心',
            '上海市闵行区传染病医院',
            '上海市闵行区结核病防治院',
            '上海市闵行区精神卫生中心',
            '上海市闵行区吴泾医院',
            '上海市南汇区结核病防治院',
            '上海市南汇区精神卫生中心',
            '上海市南汇区周浦医院',
            '上海市浦东新区传染病医院',
            '上海市浦东新区肺科医院',
            '上海市普陀区中山北路街道医院',
            '上海市同济大学医院',
            '上海市徐汇区精神卫生中心〓上海市龙华地段医院',
            '上海市徐汇区日晖地段医院（徐汇区斜土路街道社区卫生服务中心）',
            '上海市杨浦区精神卫生中心',
            '上海市杨浦区老年医院',
            '上海市远洋医院',
            '闸北区北站医院',
            '金陵石油化工公司南京市炼油厂职工医院',
            '南京晨光集团有限责任公司晨光医院',
            '南京港口医院',
            '南京市雨花台区中医医院',
            '南京康爱医院',
            '南京浦镇车辆厂医院',
            '南京市白下区中医院',
            '南京市白下医院',
            '南京市城建医院',
            '南京市第一医院分院〓南京市雨花医院',
            '南京市红十字医院',
            '南京市建邺医院',
            '南京市秦淮医院',
            '南京市秦淮中医医院',
            '南京市市级机关医院',
            '南京市下关区中医医院',
            '南京市下关医院',
            '南京市玄武区中医医院',
            '杭州市安康医院',
            '杭州市上城区中医医院',
            '杭州市萧山区第六人民医院〓杭州市萧山区中医骨伤科医院',
            '杭州市余杭区第二人民医院',
            '杭州市余杭区第三人民医院',
            '萧山经济技术开发区医院',
            '浙江老年关怀医院〓杭州市拱墅区中医院',
            '湖南黄兴医院',
            '广州白云精神康复医院',
            '广州东沙医院(原广州造船厂职工医院)',
            '广州市老人院医院',
            '广州市越秀区中医杂病医院',
            '广州友好医院(原广州消化病医院)',
            '西安市安康医院',
            '西安市长安区医院',
            '西安市雁塔截瘫康复医疗中心',
            '西安中西医结合医院',
            '北京市999急救中心（北京市红十字会急诊抢救中心）',
            '北京市宣武区精神病医院',
            '黄浦区肿瘤防治院',
            '上海市黄浦区传染病医院',
            '上海市卢湾区精神卫生中心',
            '上海市民政第三精神卫生中心',
            '杭州市第一人民医院分院',
            '杭州市上城区中西医结合医院〓杭州不孕不育专科医院',
            '杭州市西湖区第二人民医院',
            '杭州市西湖区留下（人民）医院',
            '杭州市下城区中西医结合医院',
            '杭州市下城区中医院',
            '杭州市萧山区第二人民医院',
            '杭州市萧山区第三人民医院',
            '北京公安医院',
            '北京工人疗养院(北京市西山医院、北京康复中心)',
            '中国中医科学院望京医院骨伤医疗中心',
            '广州中医药大学祈福医院',
            '广州佳和医院',
            '广东省妇幼保健院海珠分院',
            '广州鸿业皮肤病专科医院',
            '广州市第一人民医院鹤洞分院',
            '中山大学附属第三医院岭南医院',
            '北京博爱医院',
            '北京朝阳医院京西院区',
            '北京大学第六医院',
            '北京地坛医院',
            '北京市结核病防治所（北京结核病控制研究所）',
            '中国人民解放军北京军区总医院（北京军区总医院分院）',
            '北京世纪坛医院',
            '北京市急救中心',
            '北京友谊医院',
            '清华大学玉泉医院',
            '首都医科大学附属北京安定医院',
            '首都医科大学附属北京佑安医院',
            '中国人民解放军五一一一二医院',
            '中国医学科学院整形外科医院',
            '复旦大学附属儿科医院',
            '复旦大学附属妇产科医院=上海市红房子妇产科医院=上海市红十字妇产科医院',
            '复旦大学附属华山医院',
            '上海华山医院',
            '上海市精神卫生中心(总部)',
            '上海市精神卫生中心分部',
            '上海市皮肤病性病医院(原上海市遵义医院)',
            '上海市眼科医院〓上海市眼病中心防治所',
            '上海市第一妇婴保健院浦东分院',
            '南京市传染病医院〓南京市第二医院',
            '南京市钟阜医院',
            '南京中医药大学附属医院（江苏省中医院）',
            '杭州市中医院',
            '长沙市第七医院(原长沙铁路医院)',
            '湖南省劳动卫生职业病防治研究所',
            '湖南省中医学院附属二医院',
            '广州市妇婴医院',
            '广州市红十字会医院昌岗分院',
            '广州市中西医结合医院（花都区中医院）',
            '广州医学院羊城医院（羊城铁路总公司广州医院）',
            '陕西省结核病防治院',
            '郑州铁路局西安中心医院',
            '北京市安康医院',
            '上海交通大学医学院附属第三人民医院（宝钢医院）',
            '杭州市余杭区第一人民医院（浙江大学医学院附属第二医院余杭分院）',
            '杭州市萧山区第一人民医院',
            '杭州市萧山区中医院',
            '杭州市整形医院〓杭州市手外科医院',
            '浙江萧山医院(萧山区妇女保健院、萧山区第五人民医院)',
            '长沙市中心医院分院(原长沙市第二医院)',
            '广州市民政局精神病院',
            '上海市长宁区中心医院〓上海市长宁区红十字医院',
            '上海市闵行区中心医院〓上海市瑞金集团闵行医院',
            '萧山区精神病医院',
            '广东三九脑科医院',
            '北京朝阳医院',
            '广州市番禺区中医院（仅限骨伤科）',
            '陕西省第二人民医院(原陕西省商业医院)',
            '北京大学首钢医院',
            '广东省交通医院',
            '广州东方医院',
            '广州市荔湾区中医医院',
            '北京丰台医院(原丰台铁路中心医院)',
            '上海交通大学医学院附属仁济医院崇明分院',
            '上海市奉贤区中医医院',
            '上海市青浦区中医医院',
            '上海市市北医院',
            '上海市杨浦区市东医院',
            '杭州市烧伤医院（杭州笕桥医院）',
            '杭州市第三人民医院',
            '武警湖南省总队医院',
            '广州医科大学附属第五医院=广州医学院港湾医院=广州港港湾医院',
            '广州市白云区妇幼保健院',
            '广州市荔湾区红十字会医院',
            '陕西省新安中心医院',
            '陕西省邮电医院',
            '陕西省中西医结合医院',
            '陕西正和医院',
            '西安电力中心医院',
            '西安航空发动机公司职工医院',
            '西安航天总医院',
            '中国北车集团西安车辆厂职工医院',
            '西安北环医院',
            '西安市凤城医院',
            '上海宝钢冶金建设公司职工医院〓中冶医院',
            '上海市奉贤区传染病医院〓上海市奉贤区古华医院',
            '上海市松江区方塔中医医院',
            '广州工伤康复医院',
            '西安黄河医院',
            '西安惠安医院',
            '西安交通大学医院',
            '中国民航总医院',
            '湖南省马王堆医院（湖南省老年医院、湖南省马王堆疗养院）',
            '中山大学附属第二医院南院',
            '中山大学附属肿瘤医院',
            '广东省第二中医院白云院区',
            '中国航天科技集团总医院',
            '北京中医药大学东方医院',
            '中国人民武装警察部队总医院',
            '解放军总医院第一附属医院（中国人民解放军第304医院）',
            '复旦大学附属眼耳鼻喉科医院',
            '浙江省肿瘤医院',
            '浙江大学医学院附属第二医院',
            '浙江大学医学院附属第一医院',
            '浙江省新华医院=浙江中医药大学附属第二医院',
            '广东省中医院芳村分院（广州市慈善医院）',
            '陕西省人民医院',
            '陕西省肿瘤医院',
            '武警陕西总队医院',
            '西安交通大学第二医院',
            '西安交通大学口腔医院',
            '西安交通大学医学院第二附属医院',
            '西安交通大学医学院第一附属医院',
            '杭州师范学院附属医院',
            '武警浙江省总队杭州医院〓之江医院',
            '陕西省友谊医院',
            '北京市第一中西医结合医院',
            '中国人民解放军陆军总医院',
            '航天海鹰中心医院(原中国航天工业总公司七三一医院)',
            '上海市浦东医院',
            '中国人民解放军火箭军总医院',
            '北京市昌平区南口铁路医院',
            '北京市顺义区结核病防治所',
            '北京市顺义区空港医院',
            '北京市通州区中西医结合骨伤医院〓北京市通州区工业品公司运通医院',
            '北京市西城区妇婴医院',
            '北京安定门中医医院',
            '南京市江宁区第二人民医院',
            '南京市栖霞区龙潭医院',
            '临安市昌化镇中医骨伤科医院',
            '长沙市程裕医院',
            '广东职业技术师范学院医院',
            '广州市海珠区第二中医院',
            '广州市江高人民医院',
            '广州市交通运输职工医院',
            '广州市越秀区正骨医院分院',
            '中国人民武装警察部队广东总队医院番禺分院',
            '广州紫荆医院',
            '广州市萝岗区红十字会医院',
            '中山大学附属第六医院南沙分院',
            '广州市南沙区第一人民医院',
            '从化市中医医院',
            '增城市中医医院',
            '广东省水电医院',
            '广州市番禺疗养院',
            '北京市房山区第二医院（北京市房山区良乡医院）',
            '北京民康医院',
            '北京市昌平区妇幼保健院',
            '北京市昌平区中医院',
            '北京市潮白河骨伤科医院',
            '北京市大兴区妇幼保健院',
            '北京市大兴区精神病院',
            '北京市大兴区人民医院',
            '北京市房山区第一医院',
            '北京市房山区老年病医院',
            '北京市顺义区妇幼保健院',
            '北京市护国寺中医医院',
            '北京市怀柔区第一医院',
            '北京市怀柔区妇幼保健院',
            '北京市怀柔区中医院',
            '北京市门头沟区妇幼保健院',
            '北京市门头沟区医院',
            '北京市门头沟区中医院',
            '北京市平谷区医院',
            '北京市平谷区中医院',
            '北京市仁和医院',
            '北京市顺义区医院',
            '北京市顺义区中医院',
            '北京市通州区妇幼保健院',
            '北京市通州区老年病医院',
            '北京市通州区潞河医院',
            '北京市通州区新华医院',
            '密云县太师屯镇社区卫生服务中心',
            '密云县妇幼保健院',
            '密云县中医院',
            '延庆县第二医院',
            '延庆县妇幼保健院',
            '延庆县医院',
            '延庆县中医院',
            '宁河县医院',
            '中国人民解放军第二六三医院',
            '中国人民解放军六六0五五医院',
            '中国人民解放军五一一一六医院',
            '北京皇城股骨头坏死专科医院',
            '崇明县第二人民医院',
            '崇明县传染病医院',
            '复旦大学附属中山医院青浦分院青浦区中心医院',
            '上海市奉贤区中心医院',
            '上海市第六人民医院金山分院',
            '上海市燎原农场职工医院',
            '上海市南市区妇幼保健院',
            '上海市南市区中西医结合医院',
            '复旦大学附属中山医院青浦分院（上海市青浦区中心医院）',
            '上海市青浦区朱家角人民医院',
            '上海市松江区中心医院',
            '上海市新海农场职工医院',
            '上海交通大学医学院附属新华医院崇明分院(原崇明县中心医院)',
            '上海市金山区中心医院漕泾分院',
            '高淳县人民医院',
            '高淳县中医院',
            '溧水县人民医院',
            '溧水县中医院',
            '南京市江宁区妇幼保健所',
            '南京市青龙山精神病院',
            '扬郭医院(原扬子石油化工有限责任公司职工医院)',
            '中国石化集团南京化学工业有限公司职工医院',
            '淳安县第一人民医院',
            '富阳市第二人民医院',
            '富阳市妇幼保健院',
            '富阳市人民医院',
            '富阳市中医骨伤科医院',
            '杭州市拱墅区半山人民医院',
            '建德市第一人民医院',
            '临安市人民医院',
            '桐庐县第一人民医院',
            '中国水利水电第八中心医院',
            '湖南省煤炭坝煤矿职工医院',
            '浏阳市骨伤科医院(原浏阳市社港医院)',
            '浏阳市人民医院',
            '浏阳市中医院',
            '宁乡县精神病院',
            '宁乡县中医院',
            '望城县人民医院',
            '从化市妇幼保健院',
            '南方医科大学第五附属医院(从化市中心医院)',
            '从化市中医院',
            '广东省水电二局医院',
            '广州市荔湾区中西医结合医院',
            '增城市妇幼保健院〓增城市荔江医院',
            '增城市人民医院',
            '增城市新塘医院',
            '增城市中医院',
            '番禺南村镇医院',
            '中国人民解放军武装警察8730部队医院',
            '广州市花都区人民医院宝华院区',
            '高陵县医院',
            '高陵县中医院',
            '户县人民医院',
            '户县中医院',
            '蓝田县医院',
            '蓝田县中医院',
            '临潼妇幼保健院',
            '陕西省核工业四一七医院〓临潼职业病医院',
            '陕西省森林工业职工医院',
            '铁道部第一工程局西安医院',
            '西安市临潼区人民医院',
            '西安一四一医院',
            '周至县人民医院',
            '周至县中医院',
            '北京市昌平区精神卫生保健院',
            '北京市昌平区南口医院',
            '北京市大兴区红星医院',
            '北京市门头沟区龙泉医院',
            '北京市门头沟区斋堂医院',
            '北京市平谷区第二医院',
            '北京市平谷区妇幼保健院',
            '北京市平谷区精神病医院',
            '北京市昌平区沙河医院',
            '铁道部南口机车车辆厂医院',
            '崇明县妇幼保健院',
            '崇明县精神卫生中心',
            '崇明县康乐医院',
            '崇明县庙镇人民医院',
            '上海市奉贤区奉城医院',
            '奉贤区精神卫生中心',
            '上海市金山区亭林医院',
            '上海市奉贤区奉城人民医院',
            '奉贤区精神卫生中心（上海市奉贤区海湾医院）',
            '上海市金山区疾病防治控制中心〓上海市金山区东林医院',
            '上海市金山区精神卫生中心',
            '上海市松江区妇幼保健院',
            '上海市松江区精神卫生中心',
            '上海市松江区乐都医院',
            '上海市松江区泗泾医院',
            '江浦县人民医院',
            '南京钢铁集团有限公司医院',
            '南京市江宁区中医院',
            '南京市六合区大厂医院〓南京市大厂中西医结合医院',
            '南京市六合区人民医院',
            '南京市六合区中医院',
            '南京市浦口区中心医院',
            '南京市浦口区中医院',
            '南京市浦口医院',
            '南京市栖霞区迈皋桥医院',
            '南京市栖霞区医院',
            '南京市玄武医院',
            '淳安县第二人民医院',
            '淳安县中医医院',
            '富阳市第三人民医院〓富阳市精神病防治院',
            '富阳市中医医院',
            '杭州市横河医院',
            '临安市昌化人民医院',
            '临安市于潜人民医院',
            '临安市中医医院',
            '桐庐县第二人民医院',
            '桐庐县中医医院',
            '浙江大学校医院',
            '长沙县第一人民医院',
            '长沙市年轮骨科医院',
            '高陵县妇幼保健院',
            '西安市阎良区人民医院',
            '中国航空科技集团总公司六三0所职工医院',
            '北京市宣武区妇幼保健院',
            '上海市青浦区精神卫生中心',
            '富阳市新登中医骨伤科医院',
            '建德市第二人民医院',
            '建德市第三人民医院',
            '建德市中医医院',
            '西安开泰中医医院',
            '北京京东中美医院',
            '北京市第一中西医结合医院东坝院区(原东坝医院)',
            '北京市房山区燕山医院',
            '北京王府中西医结合医院',
            '南京同仁医院',
            '南京明基医院',
            '广州市南沙区中医院',
            '武警广东省总队医院番禺分院',
            '中山大学医院',
            '广州市南沙中心医院',
            '广州医科大学附属第四医院',
            '广东省妇幼保健院（番禺院区）',
            '北京回龙观医院',
            '北京市昌平区中西医结合医院',
            '密云县鼓楼社区卫生服务中心（密云县滨阳医院）',
            '中国人民解放军三0二医院',
            '上海市公共卫生临床中心',
            '第二军医大学长征医院南京分院',
            '徐州矿务集团第三医院',
            '杭州市第七人民医院〓杭州市精神病院',
            '广东省心血管病医院霍英东心脏中心',
            '广东省银行医院',
            '广州市白云区人和华侨医院〓〗',
            '广州市越秀区口腔医院',
            '广州医科大学附属肿瘤医院',
            '广州市精神病医院江村院区',
            '广州市中西医结合医院福宁分院',
            '西安高新医院',
            '铁道部第一工程局西安中心医院',
            '北京京煤集团总医院',
            '北京小汤山医院（北京小汤山疗养院）',
            '南京市江北人民医院',
            '北京燕化医院（北京燕化凤凰医院）',
            '北京市昌平区医院',
            '中国中医科学院广安门医院南区',
            '长庆石油勘探局有限公司矿区服务事业部职工医院（原长庆油田职工医院）',
            '上海和平眼科医院',
            '户县妇幼保健院',
            '北京大学第一医院密云医院',
            '江宁医院（南京市江宁区人民医院）',
            '复旦大学附属金山医院',
            '东莞东华医院',
            '陕西中医院大学附属大兴医院（西安大兴医院）',
            '宁乡县人民医院',
            '上海杨思医院',
            '南京市仙林鼓楼医院',
            '北京中医药大学东直门医院东区',
            '河南省胸科医院〓河南康复中心医院',
            '河南省直第三人民医院(原河南省地质医院)',
            '新疆第二济困医院',
            '中国人民解放军第二十三医院',
            '中国石油天然气运输公司职工医院',
            '米东区中医医院',
            '乌鲁木齐市友谊医院青年路医院',
            '石家庄市第二医院〓石家庄口腔医院(原石家庄人民医院)',
            '石家庄市第六医院〓石家庄市妇幼保健院',
            '石家庄市第三医院',
            '石家庄市第四医院〓石家庄市眼病防治中心〓石家庄妇产医院',
            '山西中医学院附属医院（山西中医学院附属第二中医院）',
            '太原市人民医院',
            '中国化学工程第二建设公司职工医院',
            '太原市和平医院',
            '太原市万柏林区中心医院',
            '沈阳医学院附属第二医院分院〓沈阳机车车辆厂医院',
            '沈阳急救中心',
            '沈阳市第六人民医院〓沈阳市传染病医院',
            '沈阳市妇婴医院',
            '沈阳市肛肠医院',
            '沈阳市公安医院',
            '沈阳市骨科医院',
            '沈阳市和平区中心医院〓沈阳市和平区太原街社区卫生服务中心',
            '沈阳市口腔医院',
            '沈阳市第九人民医院',
            '沈阳市七三九医院',
            '沈阳市沈河区中医院',
            '沈阳市铁西区中心医院',
            '沈阳市于洪区人民医院',
            '沈阳市于洪区中医院',
            '辽宁奉天中医院',
            '长春市口腔医院',
            '长春铁路分局长春医院',
            '吉林省电力医院',
            '吉林省前卫医院',
            '长春市妇产医院',
            '哈尔滨市第十医院〓哈尔滨市道里区人民医院',
            '黑龙江省电力医院',
            '安徽省肺科医院',
            '安徽医科大学第四附属医院',
            '安徽中医学院第二附属医院〓安徽中医学院附属针灸医院',
            '福建省级机关医院',
            '江西凤凰第一医院',
            '南昌三三四医院',
            '南昌市第五医院',
            '济南钢铁集团总公司职工医院',
            '济南市传染病医院',
            '济南市第二人民医院〓济南市眼科医院',
            '济南市第五人民医院',
            '济南市第一人民医院',
            '济南市槐荫人民医院〓济南市大肠肛门病医院',
            '山东省警官总医院',
            '青岛阜外心血管病医院',
            '青岛市第八人民医院',
            '青岛市第三人民医院',
            '河南省肛肠医疗中心〓郑州市大肠肛门病医院',
            '河南省中医药研究院附属医院',
            '郑州市第二人民医院',
            '郑州市第三人民医院',
            '郑州市妇幼保健院',
            '武汉市武昌医院（武昌铁路医院）',
            '武汉市汉阳医院（汉阳铁路中心医院）',
            '武汉市第八医院（武汉市肛肠医院）',
            '武汉市第二中西医结合医院〓武汉六七二医院',
            '武汉市第九医院',
            '武汉市第六医院',
            '武汉市第七医院',
            '武汉市第十二医院',
            '武汉市第十一医院〓武汉市红十字会医院',
            '武汉市商业职工医院',
            '武汉市武东医院〓武汉市第二精神病院',
            '武汉市结核病防治所',
            '南宁市第三人民医院〓南宁市心血管专科医院',
            '南宁市妇女儿童医院〓南宁市妇幼保健院',
            '南宁市红十字会医院',
            '南宁市中医院',
            '重庆嘉陵医院',
            '重钢总医院',
            '重庆长航医院',
            '重庆江陵医院〓长安汽车有限责任公司第一职工医院',
            '重庆市北碚区中医院',
            '重庆市第八人民医院〓重庆市市直机关直属医院',
            '重庆市第六人民医院',
            '重庆市第七人民医院',
            '重庆市第十三人民医院',
            '重庆市江北区中医院',
            '重庆市九龙坡区第二人民医院',
            '重庆市九龙坡区第三人民医院〓重庆市九龙坡区第一中医院',
            '重庆市沙坪坝区人民医院',
            '重庆市沙坪坝区中医院',
            '重庆市渝北区人民医院',
            '重庆西郊医院',
            '重庆渝北区妇幼保健院',
            '成飞医院（成都飞机工业(集团)有限责任公司医院）',
            '成都市第七人民医院',
            '成都新华医院',
            '成都铁路分局医院',
            '成都痔瘘专科医院〓成都肛肠专科医院',
            '核工业四一六医院',
            '四川省第四人民医院',
            '四川省林业中心医院',
            '四川省中医药科学院附属医院（四川省中西医结合医院、四川省中医药科学院肿瘤研究所）',
            '四川省中医药研究院中医医院（四川省第二中医医院）',
            '四川省红十字肿瘤医院',
            '贵阳市第四人民医院',
            '贵阳市第五人民医院',
            '贵阳市云岩区人民医院',
            '银川市第二人民医院',
            '银川市妇幼保健院',
            '银川市口腔医院',
            '乌鲁木齐市眼耳鼻喉专科医院',
            '乌鲁木齐市第一人民医院〓乌鲁木齐市儿童医院',
            '新疆第一济困医院',
            '新疆纺织职工医院',
            '新疆医科大学第六附属医院（新疆建工医院）',
            '新疆煤矿总医院、自治区职业病医院、自治区职业病防治院',
            '新疆乌鲁木齐石化总厂职工医院',
            '长春市朝阳区人民医院',
            '长春市第二医院',
            '吉林大学第一医院邮电医院(原吉林省邮电医院)',
            '合肥市第六人民医院〓合肥市传染病医院〓合肥市肿瘤医院',
            '福州市晋安区医院',
            '厦门大学医院',
            '厦门前埔医院',
            '厦门市第一医院思明分院',
            '河南省职工医院',
            '河南医科大学第四附属医院',
            '华中科技大学医院',
            '武汉市普仁江岸医院（铁道部江岸车辆工厂职工医院）',
            '中国建筑第三工程局武汉中心医院',
            '武汉市紫荆医院（中国南车集团武昌车辆厂职工医院）',
            '重庆市渝北区中医院',
            '成都市锦江区妇幼保健院',
            '成都市青羊区第六人民医院〓成都市青羊区中医院',
            '四川电力医院',
            '新疆维吾尔自治区人民医院分院-原交通医院',
            '长春市二道区人民医院',
            '新疆老年病医院〓新疆老年病防治研究所',
            '河北医科大学口腔医院〓河北省口腔医院',
            '武警山东总队医院',
            '广西民族医院',
            '新疆心脑血管病医院',
            '河北省儿童医院',
            '河北省人民医院',
            '河北省胸科医院〓河北省结核病防治院',
            '河北省中医院',
            '河北医科大学第二医院',
            '河北医科大学第三医院',
            '河北医科大学第四医院',
            '河北医科大学中医学院附属医院',
            '石家庄市第一医院',
            '中国人民解放军白求恩国际和平医院',
            '中国人民解放军第二六四医院',
            '山西省心血管疾病医院',
            '山西省眼科医院',
            '山西省肿瘤医院〓山西省第三人民医院',
            '山西省中西医结合医院（太原铁路中心医院，山西中医学院中西医结合医院）',
            '山西省中医院',
            '辽宁省人民医院(辽宁省心血管病医院)',
            '辽宁省中医院（辽宁中医药大学附属医院）',
            '辽宁省肿瘤医院',
            '辽宁省肛肠医院（辽宁中医药大学附属第三医院）',
            '沈阳二四二医院',
            '中国人民解放军沈阳军区总医院',
            '沈阳市第四人民医院(沈阳市眼科医院)',
            '沈阳市第一人民医院(沈阳市脑科医院)',
            '辽宁省儿童医院(沈阳市儿童医院)',
            '沈阳市第三人民医院(沈阳市红十字会医院)',
            '沈阳医学院附属第二医院〓沈阳医学院沈洲医院〓沈阳市心脑血管医院',
            '中国人民解放军第二〇二医院',
            '中国人民解放军第四六三医院',
            '中国医科大学附属口腔医院',
            '长春市儿童医院',
            '长春市中心医院长春市医院',
            '长春市中医院',
            '长春中医药大学附属医院（吉林省中医院）',
            '吉林大学第二医院',
            '吉林省中西医结合医院',
            '吉林省人民医院',
            '吉林省肿瘤医院',
            '中国人民解放军第二零八医院',
            '哈尔滨二四二医院（哈尔滨市第三医院）',
            '哈尔滨市第四医院',
            '哈尔滨市第五医院',
            '哈尔滨市儿童医院',
            '哈尔滨市骨伤医院',
            '哈尔滨市红十字中心医院',
            '哈尔滨医科大学附属第二医院',
            '哈尔滨医科大学附属第三医院（哈尔滨医科大学附属肿瘤医院）',
            '哈尔滨医科大学附属第四医院',
            '哈尔滨医科大学附属第一医院',
            '黑龙江中医药大学附属第二医院',
            '黑龙江中医药大学附属第一医院',
            '中国人民解放军第二一一医院',
            '哈尔滨市中医医院',
            '黑龙江省中医院南岗分院',
            '哈尔滨中德骨科医院',
            '安徽医科大学第一附属医院',
            '安徽中医学院第一附属医院',
            '合肥市第二人民医院',
            '安徽医科大学第三附属医院（合肥市第一人民医院、合肥市滨湖医院）',
            '福建医科大学附属协和医院',
            '中国人民解放军第一0五医院',
            '福建省妇幼保健院',
            '福建省立医院',
            '四川省骨科医院',
            '福建省肿瘤医院',
            '福建医科大学附属第一医院',
            '福州市传染病医院',
            '福州市第一医院',
            '福州市第二医院',
            '厦门市中医院',
            '江西省儿童医院',
            '江西省妇幼保健院',
            '江西省人民医院',
            '江西中医学院附属医院（江西省中医院）',
            '江西省肿瘤医院（江西省第二人民医院）',
            '南昌大学第二附属医院',
            '南昌大学第一附属医院',
            '南昌大学第三附属医院〓南昌市第一医院',
            '南昌大学附属口腔医院',
            '济南市第四人民医院',
            '济南市妇幼保健院',
            '济南市中心医院',
            '山东大学第二医院',
            '山东大学齐鲁儿童医院',
            '山东大学齐鲁医院',
            '山东省立医院',
            '山东省千佛山医院',
            '山东省胸科医院',
            '山东省肿瘤医院',
            '山东中医药大学第二附属医院(原济南铁路中心医院)',
            '山东中医药大学附属医院',
            '中国人民解放军第四五六医院〓中国人民解放军四十四医院',
            '中国人民解放军济南军区总医院',
            '青岛大学附属医院（包括本部、西海岸医疗中心、北院区和东院区）',
            '青岛市传染病医院〓青岛市第六人民医院',
            '青岛儿童医院〓青岛市妇女儿童医疗保健中心',
            '青岛市海慈医疗集团',
            '青岛市市立医院（集团）（包括本部西院区和东院区）',
            '青岛市中心医院',
            '中国人民解放军海军第四0一医院（包括本部南院区和北院区）',
            '山东大学齐鲁医院青岛院区',
            '河南省人民医院',
            '河南省中医院',
            '河南省肿瘤医院',
            '武警河南总队医院',
            '郑州大学第二附属医院',
            '郑州大学第三附属医院〓河南省妇幼保健院',
            '郑州大学第五附属医院',
            '郑州大学第一附属医院',
            '郑州人民医院',
            '郑州市第一人民医院',
            '郑州市儿童医院',
            '郑州市骨科医院',
            '郑州市金水区人民医院',
            '郑州市中医院',
            '广州军区武汉总医院',
            '湖北省妇幼保健院（湖北省妇女儿童医院）',
            '湖北省中西医结合医院（湖北省新华医院）',
            '湖北省中医院（湖北中医药大学附属医院）',
            '湖北省肿瘤医院',
            '华中科技大学同济医学院附属梨园医院',
            '武汉大学人民医院（湖北省人民医院）',
            '武汉大学中南医院',
            '武汉市同仁医院=武汉市第三医院',
            '武汉市第四医院(华中科技大学同济医学院附属普爱医院)',
            '武汉市妇女儿童医疗保健中心（武汉市儿童医院、武汉市妇幼保健院）',
            '武汉市精神卫生中心',
            '武汉市中心医院=武汉市第二医院（包含南京路、后湖院区）',
            '武汉市中医院',
            '华中科技大学同济医学院附属协和医院',
            '武汉亚洲心脏病医院',
            '中国人民解放军第一六一中心医院',
            '武汉科技大学附属天佑医院',
            '广西医科大学第三附属医院（南宁市第二人民医院）',
            '广西医科大学第一附属医院',
            '广西医科大学附属口腔医院',
            '广西医科大学附属肿瘤医院',
            '广西中医药大学第一附属医院',
            '广西壮族自治区妇幼保健院',
            '广西壮族自治区人民医院',
            '南宁市第一人民医院',
            '中国人民解放军三0三医院',
            '广西中医学院附属瑞康医院',
            '武警重庆总队医院',
            '中国人民解放军三二四医院',
            '重庆市第五人民医院',
            '重庆市急救医疗中心（重庆市第四人民医院）',
            '重庆市中医院',
            '重庆市肿瘤医院',
            '重庆医科大学附属第二医院',
            '重庆医科大学附属第一医院',
            '重庆医科大学附属儿童医院（重庆市儿童医院）',
            '重庆医科大学附属口腔医院',
            '重庆市第一人民医院（重庆市中西医结合医院）',
            '成都市第二人民医院',
            '成都市第三人民医院',
            '成都市第十人民医院〓成都市传染病医院',
            '成都市中西医结合医院〓成都市第一人民医院',
            '成都大学附属医院（原成都铁路局成都铁路中心医院）',
            '成都中医药大学附属医院',
            '四川大学华西第二医院',
            '四川大学华西第四医院〓四川大学华西职业病医院',
            '四川大学华西口腔医院',
            '四川大学华西医院',
            '四川省第三人民医院',
            '四川省人民医院',
            '四川省肿瘤医院',
            '中国人民解放军成都军区总医院',
            '成都体育学院附属体育医院',
            '贵州医科大学附属医院',
            '贵阳中医学院第二附属医院',
            '贵阳中医学院第一附属医院',
            '贵州省人民医院',
            '成都军区昆明总医院（43医院）',
            '昆明市第一人民医院',
            '昆明市妇幼保健院',
            '昆明市延安医院',
            '昆明市中医院',
            '昆明医科大学第二附属医院（工人医院）',
            '昆明医科大学第一附属医院(云大医院)',
            '云南省第一人民医院（昆华医院）',
            '云南省中医医院',
            '云南省肿瘤医院〓昆明医科大学第三附属医院',
            '武警云南省边防总队医院',
            '银川市第一人民医院',
            '中国人民解放军第五医院',
            '乌鲁木齐市口腔医院',
            '乌鲁木齐市友谊医院',
            '新疆生产建设兵团总医院',
            '新疆石油管理局乌鲁木齐医院',
            '新疆维吾尔自治区维吾尔医医院',
            '新疆维吾尔自治区中医医院',
            '新疆医科大学第二附属医院',
            '新疆医科大学第五附属医院',
            '新疆医科大学第一附属医院',
            '新疆医科大学附属肿瘤医院',
            '中国人民解放军第四七四医院',
            '中国人民解放军兰州军区乌鲁木齐总医院',
            '武警河北总队医院',
            '山西焦煤西山煤电集团公司职工总医院',
            '山西省第二人民医院',
            '太原市第三人民医院（太原市传染病院）',
            '中国人民武装警察部队辽宁省总队医院（武警辽宁省总队医院）',
            '吉林省武警总队医院',
            '一汽总医院',
            '哈尔滨市传染病医院',
            '黑龙江省第二医院〓黑龙江省职业病防治院',
            '安徽省精神卫生防治中心〓合肥市第四人民医院〓合肥市精神病医院',
            '福建省第二人民医院',
            '福州市第四医院（福州市神经精神病防治院）',
            '福州市中医院',
            '厦门市仙岳医院',
            '南昌市第三医院',
            '南昌市洪都中医院',
            '武警江西总队医院',
            '长江航运总医院(武汉脑科医院)',
            '武汉钢铁(集团)公司第二职工医院',
            '武汉市第五医院',
            '广西骨伤医院',
            '南宁市第四人民医院',
            '成都市第八人民医院',
            '昆明市第二人民医院',
            '昆明市第三人民医院',
            '云南省第三人民医院',
            '乌鲁木齐市妇幼保健院',
            '乌鲁木齐市中医院',
            '中国人民武装警察部队新疆总队医院',
            '哈尔滨市第二医院',
            '银川市中医院',
            '合肥市第三人民医院',
            '安徽省立儿童医院',
            '重庆市第九人民医院',
            '成都市第六人民医院',
            '沈阳市第十人民医院〓沈阳市胸科医院',
            '黑龙江省医院',
            '南昌市第二医院（江西省中西医结合医院、江西中医药大学附属中西医结合医院）',
            '华中科技大学同济医学院附属同济医院',
            '沈阳市中西医结合医院〓沈阳市第七人民医院〓沈阳市皮肤病医院',
            '中国医科大学第二附属医院（中国医科大学附属盛京医院）',
            '中国医科大学第一附属医院',
            '山东省立医院耳鼻喉医院(原山东煤矿总医院)',
            '重庆西南铝医院',
            '重庆市巴南区第二人民医院（花溪医院）',
            '成都市金牛区人民医院',
            '河南中医药大学第一附属医院',
            '济南市第三人民医院',
            '武警安徽省总队医院',
            '贵阳市第一人民医院',
            '武汉市第一医院（武汉市中西医结合医院）',
            '成都军区八一骨科医院',
            '中国人民解放军第九四医院',
            '安徽医科大学第二附属医院',
            '山东省交通医院',
            '沈阳医学院附属中心医院〓沈阳医学院奉天医院〓沈阳市中心医院',
            '昆明市儿童医院',
            '四川省妇幼保健院',
            '银川市第三人民医院',
            '武警宁夏总队医院',
            '合肥市第八人民医院',
            '中国医科大学附属第四医院',
            '河北医科大学第一医院',
            '贵阳市妇幼保健院',
            '郑州市中心医院',
            '河北医科大学以岭医院〓河北以岭医药研究所附属医院',
            '哈尔滨市朝鲜民族医院',
            '徐州爱心医院(原徐州市民政医院)',
            '徐州市财贸职工医院',
            '厦门仁安医院',
            '山东省医学科学院附属医院〓山东内分泌代谢病医院',
            '山东省邮电医院',
            '青岛市骨伤科医院',
            '淄博红十字会骨病医院',
            '烟台市肿瘤医院〓烟台市职业病防治院',
            '济宁市口腔医院〓济宁市牙病防治中心',
            '郑州大学第四附属医院',
            '河南曙光中西医结合医院',
            '成都中山医院（四川省邮电医院）',
            '昆明市官渡区人民医院',
            '昆明市官渡区中医院',
            '昆明市盘龙区人民医院',
            '昆明市盘龙区中医院',
            '昆明市五华区人民医院',
            '昆明市五华区中医院',
            '昆明同仁医院',
            '新疆天山医院',
            '藁城市妇幼保健院',
            '藁城市人民医院',
            '藁城市中西医结合医院〓藁城市中医院',
            '河北东方中西医结合医院',
            '河北神经外科医院',
            '河北省老年病医院(原河北医学科学院附属医院)',
            '河北省心脑血管医院',
            '河北医科大学附属石家庄第五医院〓（原石家庄市第五医院）',
            '石家庄市中心医院（原石家庄铁路中心医院）',
            '华北制药厂职工医院〓石家庄市偏瘫医院',
            '井陉矿区医院',
            '鹿泉市人民医院',
            '鹿泉市中医院',
            '石家庄第八医院',
            '石家庄第一人民医院分院〓石家庄建南医院',
            '石家庄瑞德医院(原石家庄炼油厂医院)',
            '石家庄市第九医院（石家庄市交通医院）',
            '石家庄市桥西区医院',
            '石家庄市友谊烧伤医院',
            '中国石化石家庄炼油厂医院',
            '山西医科大学第三医院〓山西省建筑职工医院',
            '太原内分泌糖尿病专科医院',
            '山西三针脑血管病医院',
            '太原市中西医结合医院',
            '山西红十字口腔医院',
            '辽宁电力中心医院(原东北电业中心医院)',
            '辽宁省糖尿病治疗中心',
            '辽宁省血栓病中西医结合医疗中心〓沈阳市第二中医院〓沈阳市苏家屯区中医院',
            '沈阳东药医院',
            '沈阳二0四医院',
            '沈阳市铁西区华康医院',
            '沈阳市安宁医院',
            '沈阳市大东区第二中医院',
            '中国医科大学附属第一医院大东医院〓沈阳市大东区人民医院〓沈阳市大东区小东',
            '沈阳市东陵区中心医院',
            '沈阳市和平区妇婴医院',
            '沈阳市和平区红十字会医院',
            '沈阳市皇姑区中心医院〓沈阳市皇姑区怒江社区卫生服务中心',
            '沈阳市浑南新区医院〓沈阳市浑南新区五三社区卫生服务中心',
            '沈阳市交通医院',
            '沈阳市沈河区人民医院〓沈阳市沈河区皇城社区卫生服务中心',
            '沈阳市苏家屯区妇婴医院',
            '沈阳市苏家屯区精神卫生防治中心〓沈阳市苏家屯区红十字会医院',
            '沈阳市第十一人民医院〓沈阳市苏家屯区中心医院',
            '沈阳市铁西区中医院',
            '沈阳市中医院',
            '中国医科大学心理医院',
            '沈阳中大骨科医院',
            '沈阳维康医院',
            '沈阳经济技术开发区人民医院〓沈阳市铁西区昆明湖社区卫生服务中心',
            '航空航天工业部长春二四六医院',
            '长春市传染病医院',
            '长春市结核病医院',
            '长春市绿园区人民医院',
            '长春中医学院附属风湿病医院',
            '长春中医学院针灸骨伤医院',
            '吉林北方肝胆病医院长春传染病医院',
            '吉林大学中日联谊医院分院',
            '吉林心脑血管病医院',
            '哈尔滨空军九三一六三部队医院',
            '哈尔滨市道外区人民医院',
            '哈尔滨市第八医院',
            '哈尔滨市第九医院',
            '哈尔滨市第六医院',
            '哈尔滨市第七人民医院',
            '哈尔滨市南岗区人民医院',
            '黑龙江海员总医院〓黑龙江省交通医院',
            '黑龙江省邮电医院',
            '中国人民解放军哈尔滨宏征医院',
            '徐州电力医院',
            '徐州市第六人民医院',
            '徐州市第三人民医院〓徐州市肿瘤医院',
            '徐州市电力医院',
            '徐州市妇幼保健院',
            '徐州市矿山医院',
            '中国人民解放军83567部队医院',
            '中国石化集团管道储运公司职工医院',
            '温州市康宁精神病医院',
            '温州中山医院',
            '中国人民解放军一一八医院',
            '安徽省红十字会医院',
            '合肥钢铁集团有限公司职工医院',
            '中铁四局集团中心医院',
            '福州市第八医院(原福州铁路分局福州铁路中心医院)',
            '福州市第六医院〓福建省老年医院',
            '福州市第三医院〓福州市鹤龄医院福州市鹤龄医院',
            '福州市第五医院(原福州市城南医院)',
            '福州市二化集团有限公司职工医院〓福州东城医院',
            '福州市鼓楼区医院',
            '福州马尾海军医院',
            '厦门市第一医院鼓浪屿分部',
            '江西江纺有限责任公司职工医院',
            '南昌钢铁有限责任公司职工医院',
            '济南施尔明眼科医院',
            '济南市长清区人民医院',
            '济南市长清区中医院',
            '济南市市中区人民医院',
            '济南医院〓济南市职业病防治院',
            '山东省地矿职工医院',
            '山东省电力中心医院',
            '山东省劳改局中心医院',
            '山东省荣军医院',
            '山东省中医药研究所',
            '青岛钢铁总公司职工医院',
            '黄岛区人民医院',
            '青岛大学医学院松山医院',
            '青岛肛肠医院〓青岛市市北区医院',
            '青岛古镇正骨医院',
            '青岛脊椎病医院〓青岛市李沧区医院',
            '青岛市第九人民医院(原青岛铁路医院)',
            '青岛市第四人民医院〓青岛市胸科医院',
            '青岛市黄岛区中医院〓青岛经济技术开发区第二人民医院',
            '青岛市口腔医院',
            '青岛市瑞华医院',
            '青岛市市北区中医医院',
            '青岛市市南区人民医院',
            '青岛协合妇产医院',
            '中国南车集团四方机车车辆有限责任公司职工医院',
            '淄博市淄川区中医院',
            '青岛市城阳区第三人民医院',
            '山东铝业公司医院',
            '淄博矿业集团双山医院',
            '淄博市博山区医院',
            '淄博市博山区中医院',
            '淄博市第七人民医院',
            '淄博市第四人民医院〓淄博市传染病医院〓淄博市肿瘤医院',
            '淄博市临淄区人民医院',
            '淄博市临淄区中医院',
            '淄博市张店区中医院',
            '淄博市淄川区医院',
            '淄博周村区人民医院',
            '烟台肺科医院',
            '烟台海港医院',
            '烟台业达医院（烟台经济技术开发区医院、皮肤病防治所、烟台眼科医院）',
            '烟台市福山区人民医院',
            '烟台市芝罘医院',
            '牟平区第二人民医院',
            '济宁市任城区中医院',
            '济宁市第二人民医院',
            '济宁市第四人民医院〓济宁市传染病院',
            '济宁市妇女儿童医院〓济宁市妇幼保健院',
            '济宁市市中区妇幼保健院〓济宁乳腺病医院',
            '济宁市中区人民医院',
            '兖矿集团公司第三医院',
            '河南电力医院',
            '河南省建筑职工医院',
            '河南中医学院第三附属医院(原河南省中医学院医院)',
            '郑州煤炭工业集团有限责任公司总医院',
            '郑州市第一按摩医院',
            '郑州市中原区人民医院',
            '国营武昌造船厂职工医院',
            '武汉老年病医院(原武汉市东湖医院)',
            '武汉市妇幼保健院',
            '武汉市民政局精神病院',
            '中国人民解放军第三三零三工厂医院',
            '佛山市顺德区伍仲珮纪念医院',
            '南海区黄岐医院〓南海区第六人民医院',
            '佛山市禅城区张槎医院〓佛山市中医院禅城高新区医院',
            '佛山市第五人民医院',
            '佛山市口腔医院〓佛山科学技术学院附属医院',
            '佛山市慢性病防治院',
            '佛山市南海区大沥医院〓佛山市南海区第五人民医院',
            '佛山市南海区第三人民医院（南海区里水医院）',
            '佛山市南海区第二人民医院(原平洲医院)、广州医学院附属广佛医院',
            '佛山市南海区松岗医院〓佛山市南海经济开发区人民医院松岗分院',
            '佛山市南海区西樵医院〓佛山市南海区第四人民医院',
            '佛山市南海区盐步医院〓佛山市南海区第七人民医院',
            '佛山市石湾区人民医院',
            '佛山市顺德区陈村医院',
            '佛山市顺德区大良医院（大良仁爱医院）',
            '佛山市顺德区桂洲医院',
            '佛山市顺德区均安镇医院',
            '佛山市顺德区乐从医院',
            '佛山市顺德区勒流镇医院',
            '佛山市顺德区龙江镇医院',
            '佛山市顺德区伦教医院',
            '佛山市顺德区马洲医院',
            '佛山市顺德区新容奇医院（容奇医院）',
            '佛山市顺德区伍仲佩纪念医院(原凤山医院)',
            '顺德市第一人民附属杏坛医院（顺德区杏坛医院）',
            '顺德区北滘医院',
            '佛山市南海区红十字会医院〓佛山市南海区罗村医院',
            '南宁市第七人民医院〓南宁市中西医结合医院',
            '南宁市第五人民医院〓南宁市精神病院',
            '南宁市社会福利医院',
            '南宁市邕宁区中医院',
            '武鸣县人民医院',
            '武鸣县中医院',
            '天府矿务局总医院',
            '西南车辆制造厂职工医院〓重庆渝西医院',
            '重庆市第十二人民医院(原重庆市肺科医院)',
            '重庆市万州区第二人民医院',
            '重庆市万州区妇幼保健院',
            '重庆市万州区中医医院',
            '重庆市渝中区中医院',
            '重庆望江医院',
            '中铁二局集团中心医院',
            '成都儿童专科医院',
            '成都市锦江区人民医院',
            '成都市西区医院',
            '四川省第五人民医院(四川省老年病研究所)',
            '四川省建筑医院',
            '白云区第一人民医院',
            '贵阳市第三人民医院',
            '贵阳市肺科医院',
            '贵阳市口腔医院',
            '乌当区人民医院',
            '云南省急救中心',
            '乌鲁木齐市安宁医院（乌鲁木齐市精神病福利院）',
            '同乌鲁木齐市第四人民医院',
            '西山铁路医院',
            '河北省优抚医院(原河北省爱心医院)',
            '石家庄市桥东区医院',
            '石家庄市新华区医院',
            '太原煤炭气化有限责任公司职工医院',
            '晋西机器工业集团有限责任公司职工医院',
            '太原市中心医院集团北院(山西兴安集团职工医院)',
            '沈阳市虹桥医院',
            '长春八一医院',
            '长春东北师范大学医院',
            '长春机车厂职工医院',
            '长春客车厂职工医院',
            '长春市二道河子区人民医院',
            '长春市宽城区民族医院',
            '长春市宽城区铁北医院',
            '长春市宽城区医院',
            '长春市宽城区中医院',
            '长春市绿园区中医院',
            '长春市南关区中西医结合医院',
            '长春市南关区中医院',
            '长春市双阳区医院',
            '长春市双阳区中医院',
            '长春银龙纺织集团有限公司职工医院',
            '航空工业总公司长春二四六医院',
            '吉林大学第二医院民康医院(原长春市南关区医院)',
            '吉林大学南岭校区医院',
            '吉林工业大学医院',
            '吉林省长春拖拉机厂职工医院',
            '吉林省监狱管理局中心医院',
            '吉林省伤残康复医院',
            '吉林省胜利医院',
            '吉林省一建集团有限公司职工医院',
            '中铁第十三局集团有限公司中心医院',
            '哈尔滨电机厂医院',
            '哈尔滨锅炉厂医院',
            '哈尔滨建成集团有限公司医院',
            '哈尔滨市妇幼保健院',
            '哈尔滨市公安医院',
            '哈尔滨市口腔医院',
            '哈尔滨市老年医院',
            '哈尔滨市穆斯林医院',
            '哈尔滨市平房区人民医院',
            '哈尔滨市眼科医院',
            '哈尔滨轴承集团公司医院',
            '黑龙江省商业职工医院',
            '哈尔滨星光医院',
            '济南铁路局徐州铁路医院',
            '徐州利国医院',
            '徐州市传染病院',
            '徐州市鼓楼医院',
            '徐州市贾汪区人民医院',
            '徐州市建筑工人医院',
            '徐州市口腔医院',
            '徐州市云龙区人民医院',
            '中煤第五建设公司职工医院',
            '温州市龙湾区第一人民医院',
            '中铁四局集团第四工程有限公司职工医院',
            '安徽省水利厅职工医院(原安徽医学高等专科学校附属医院)',
            '合肥市中医肛肠医院',
            '合肥中医推拿医院',
            '中国科学技术大学医院',
            '福州市第七医院',
            '福州市台江医院',
            '厦门海沧新阳医院',
            '厦门大学附属中山医院湖里分院（厦门市湖里区医院）',
            '济南市历城区中医医院',
            '济南市历下区人民医院',
            '济南市天桥人民医院',
            '山东省红十字博爱医院〓山东省建筑医院',
            '青岛市城阳区第二人民医院',
            '青岛市城阳区人民医院',
            '青岛市市南区浮山医院',
            '青岛铁路分局淄博铁路医院',
            '淄博化建医院（中国石化集团第十建设公司职工医院）',
            '淄博市张店区人民医院〓淄博康明眼科医院',
            '烟台东方医院',
            '烟台凤凰台医院',
            '中国人民解放军第四0七医院',
            '济宁市骨伤医院',
            '郑州市第八人民医院(原郑州市精神病医院)',
            '郑州市第六人民医院〓河南省传染病医院=郑州市结核病防治所(原郑州市传染病医',
            '郑州市邙山区人民医院',
            '湖北省地质矿产局职工医院',
            '铁道部第四勘测设计院职工医院',
            '武汉大学医院',
            '武汉锅炉集团有限公司职工医院',
            '武汉凌云公司职工医院',
            '武汉石油化工厂职工医院',
            '南宁市邕宁区人民医院',
            '重庆港口医院',
            '重庆市九龙坡区精神病医院',
            '重庆市南岸区第二人民医院',
            '成都第一骨科医院',
            '成都市锦江区妇幼保健院（成都市锦江区妇产科医院）',
            '成都市青羊区妇幼保健院',
            '贵阳市花溪区人民医院〓贵阳心脑血管病医院',
            '贵州省交通医院〓贵州省公路职工医院',
            '清镇市人民医院',
            '昆明市西山区人民医院',
            '昆明市西山区红十字会医院',
            '石家庄市长安区医院〓石家庄市长安区肛肠专科医院',
            '长春市二道区第二医院',
            '吉林大学前卫校区医院',
            '东北轻合金有限责任公司职工医院',
            '哈尔滨车辆厂医院',
            '哈尔滨工业大学医院',
            '温州市红旗医院',
            '温州市龙湾区人民医院',
            '温州市鹿城区人民医院',
            '温州市瓯海区人民医院',
            '安徽省人民政府机关医院',
            '济南市历城区人民医院',
            '山东黄河医院',
            '青岛市麦岛精神病院（青岛优抚医院、青岛麦岛心理卫生医院）',
            '青岛市商业职工医院',
            '中国有色金属第七建设公司职工医院',
            '乌鲁木齐市温泉疗养院温泉医院',
            '黑龙江省口腔病防治院',
            '黑龙江省皮肤病防治研究所〓黑龙江省性病防治中心',
            '青岛市肿瘤医院',
            '辽阳省金秋医院',
            '沈阳何氏眼科医院',
            '长春市第三医院',
            '吉林大学第三医院（吉林大学中日联谊医院）',
            '一汽总医院（吉林大学第四医院）',
            '吉林大学口腔医院',
            '吉林省劳动卫生职业病防治院',
            '吉林省人民医院南区',
            '哈尔滨市肛肠医院',
            '中国人民解放军第二0三医院',
            '徐州市第二人民医院〓徐州医学院附属医院〓徐州医科大学附属医院',
            '徐州市第四人民医院〓徐州市中心医院',
            '徐州市中医院',
            '中国人民解放军第九七医院',
            '温州市第二人民医院（温州市中心医院）',
            '温州市第三人民医院（温州市人民医院）',
            '温州医学院附属第二医院',
            '温州医学院附属第一医院',
            '温州医学院附属眼视光医院',
            '安徽省立医院（安徽省立医院南区、安徽省肿瘤医院）',
            '福建省福州肺科医院',
            '福建中医学院附属人民医院',
            '福州市妇幼保健院',
            '南京军区福州总医院',
            '江西省肺科医院',
            '江西中寰医院',
            '济南市中医医院',
            '山东省精神卫生中心',
            '青岛大学医学院附属心血管病医院',
            '青岛市人民医院',
            '青岛市中西医结合医院',
            '山东省青岛疗养院',
            '思达国际心脏中心医院',
            '淄博市第一人民医院',
            '淄博市妇幼保健院〓淄博市第三人民医院',
            '淄博市中心医院',
            '淄博市中医院',
            '烟台市烟台山医院',
            '烟台市中医医院',
            '中国人民解放军第一0七医院',
            '济宁市第一人民医院',
            '济宁市中医院=济宁市工人医院',
            '山东省安康医院',
            '湖北中医学院附属医院',
            '武汉市武昌区第三医院',
            '武汉科技大学附属医院（郑州铁路局武汉中心医院）',
            '佛山市禅城区中心医院',
            '佛山市第二人民医院',
            '佛山市第一人民医院',
            '佛山市妇幼保健院',
            '佛山市南海区妇幼保健院',
            '佛山市南海区人民医院',
            '佛山市南海区中医院〓广东省中西医结合医院',
            '佛山市三水区人民医院〓佛山市第六人民医院',
            '佛山市三水区中医院（仅限骨科）〓佛山市中医院三水医院',
            '佛山市顺德区第一人民医院',
            '佛山市顺德区妇幼保健院',
            '重庆市第一中医院',
            '重庆市中山医院',
            '重庆市中西医结合医院',
            '成都市第四人民医院〓成都市精神卫生中心',
            '成都医学院第一附属医院',
            '云南省第二人民医院（云南省红十字会医院）',
            '新疆自治区胸科医院',
            '河北中医肝病医院',
            '哈尔滨市第一专科医院',
            '哈尔滨市虹桥医院',
            '徐州市第一人民医院〓徐州市红十字医院',
            '徐州市儿童医院',
            '温州市中西医结合医院',
            '温州市中医院',
            '合肥市妇婴保健院',
            '福建医科大学附属口腔医院',
            '厦门长庚医院',
            '厦门市第三医院',
            '厦门市第二医院',
            '厦门科宏眼科医院',
            '武警福建总队医院',
            '中国人民解放军第四七六医院（476医院）',
            '江西省精神病院',
            '中国人民解放军第一四八医院',
            '淄博矿业集团有限责任公司中心医院（淄博矿务局中心医院）',
            '济宁医学院附属医院',
            '广西区江滨医院',
            '广西工人医院',
            '重庆市江北区第三人民医院',
            '中航工业三六三医院（成都三六三医院）',
            '成都市青羊区第三人民医院',
            '贵航集团三00医院',
            '贵州省第二人民医院(原贵州省安宁医院)',
            '云南省妇幼保健院',
            '云南省工人医院',
            '云南省交通中心医院',
            '哈尔滨市普宁医院',
            '黑龙江省妇幼保健院',
            '徐州矿务集团第二医院',
            '徐州市矿务集团第一医院',
            '青岛市第七人民医院〓青岛市精神卫生中心',
            '中国人民解放军成都军区第四十四医院',
            '辽宁中医药大学附属第二医院（辽宁省中医药研究院）',
            '烟台毓璜顶医院=烟台市莱山区第一人民医院',
            '清镇市中医院',
            '徐州医学院第二附属医院〓徐州矿务集团总医院',
            '郑州市第十五人民医院（原上街区人民医院）',
            '厦门莲花医院',
            '山西中医学院附属第三中医院〓山西省针灸研究所',
            '安徽中医学院中西医结合医院',
            '重庆市红岭手外伤医院',
            '重庆市渝中区中医骨科医院',
            '安徽医科大学附口腔医院〓安徽省口腔医院',
            '合肥市口腔医院',
            '江夏区第一人民医院=华中科技大学协和江南医院=武汉市第十四医院',
            '重庆市九龙坡区第五人民医院',
            '中铁十七局集团中心医院〓太原市红十字并州医院',
            '中国辐射防护研究院附属医院',
            '山西煤炭中心医院',
            '山西省荣军医院',
            '山西省一0九医院',
            '山西省肛肠医院',
            '太原市第四人民医院（太原市结核病医院）',
            '太原市化工厂医院',
            '太原市商业职工医院',
            '太原市中医研究所附属医院〓太原市中医院',
            '中铁三局集团中心医院',
            '中铁十二局中心医院',
            '太原航空仪表有限公司医院',
            '太原市第二人民医院',
            '呼和浩特市中蒙医院〓呼和浩特市中蒙医研究院',
            '合肥市妇幼保健院〓合肥市第五人民医院',
            '厦门市中医院分院',
            '郑州市第九人民医院',
            '黄河中心医院',
            '南宁市第六人民医院',
            '南宁市第八人民医院',
            '武警广西总队医院',
            '海口市妇幼保健院〓海口市妇女儿童医院',
            '海口市第三人民医院（海口市琼山人民医院）',
            '海口市中医院',
            '海南南方肛肠病医院',
            '海南省安宁医院',
            '海南省妇幼保健院',
            '海南省琼山区府城医院（海口市第四人民医院、府城医院）',
            '中国人民武装警察部队海南省总队医院',
            '重庆市公共卫生医疗救治中心',
            '成华区人民医院（成华区妇幼保健院）',
            '成都市第一人民医院分院(原成都市中医院)',
            '四川大学华西第一医院西藏成办分院(原西藏自治区人民政府驻成都办事处医院)',
            '四川省交通厅公路局医院',
            '贵州省武警总队医院',
            '拉萨市人民医院',
            '甘肃省妇幼保健院',
            '甘肃省第三人民医院',
            '兰石医院',
            '兰州市城关区人民医院',
            '兰州市传染病医院（兰州市肺科医院）',
            '兰州市第二人民医院',
            '兰州市第三人民医院',
            '兰州市妇幼保健院',
            '兰州市七里河区人民医院',
            '兰州市七里河区中医医院',
            '兰州市西固区人民医院',
            '兰州市中医骨伤科医院',
            '兰州铁路局兰州分局兰西医院',
            '兰州西固区中医院',
            '青海省交通医院',
            '西宁市第二人民医院（青海大学医学院小桥分院）',
            '宁夏回族自治区中医院',
            '宁夏回族自治区妇幼保健院',
            '乌鲁木齐市第一人民医院北院(乌鲁木齐县人民医院)',
            '米东区人民医院',
            '太原市小店区人民医院',
            '太原市杏花岭区中心医院',
            '呼和浩特市妇幼保健院',
            '厦门市口腔医院',
            '海口市琼山区妇幼保健院',
            '中国人民武装警察部队海南省边防总队医院',
            '重庆市巴南区中医院',
            '长春市人民医院',
            '江西中医药大学第二附属医院（南钢职工医院）',
            '中国人民解放军第四七八医院(原空军昆明医院)',
            '新疆维吾尔自治区胸科医院',
            '中国人民解放军二六0医院',
            '山西省儿童医院',
            '山西省人民医院',
            '山西医科大学第二医院',
            '山西医科大学第一医院',
            '太原市妇幼保健院〓太原市妇女儿童医院',
            '山西大医院',
            '呼和浩特市第二医院',
            '内蒙古医科大学第二附属医院',
            '内蒙古医科大学附属医院',
            '内蒙古自治区第二医院（内蒙古妇幼保健医院）',
            '内蒙古自治区胸科医院(结核病医院)',
            '内蒙古自治区人民医院',
            '内蒙古自治区中蒙医医院',
            '中国人民解放军第二五三医院',
            '内蒙古国际蒙医医院',
            '沈阳市第五人民医院(沈阳市肿瘤医院)',
            '吉林大学第一医院',
            '哈尔滨市第一医院',
            '哈尔滨市结核病医院〓哈尔滨市胸科医院',
            '黑龙江省红十字会医院',
            '黑龙江省中医研究院（黑龙江省中医医院）',
            '安徽省妇幼保健所',
            '安徽省立新安医院(省二院南区)',
            '福州肺科医院',
            '福州市儿童医院',
            '厦门大学附属中山医院',
            '厦门市妇幼保健院',
            '厦门眼科中心',
            '中国人民解放军第一七四医院(厦门大学附属成功医院)',
            '南昌大学附属眼科医院',
            '郑州市第七人民医院〓郑州市心血管病医院',
            '河南省军区直属医院',
            '郑州颐和医院',
            '武汉大学附属口腔医院',
            '湖北省第三人民医院（湖北省中山医院）',
            '华润武钢总医院',
            '武汉市医疗救治中心（武汉市传染病医院）',
            '中国人民武装警察部队湖北省总队医院',
            '中国人民解放军四五七医院',
            '广西医科大学第二附属医院',
            '海口市皮肤性病防治中心〓海南省皮肤病医院',
            '海口市人民医院',
            '海南省农垦总局医院',
            '海南省人民医院',
            '海南省眼科医院',
            '海南省中医院',
            '海南医学院附属医院',
            '中国人民解放军一八七中心医院',
            '重庆市人民医院',
            '重庆市红十字会医院',
            '成都市妇女儿童中心医院',
            '陆军五十七医院',
            '西藏自治区人民医院',
            '中国人民解放军西藏军区总医院',
            '甘肃省人民医院',
            '甘肃省中医院',
            '兰州大学第二附属医院',
            '兰州大学第一附属医院',
            '中国人民解放军兰州军区兰州总医院',
            '兰州市第一人民医院',
            '中国人民解放军第四七三医院（空军兰州医院）',
            '兰州军区总院安宁分院',
            '中国人民解放军第一医院（兰州三爱堂医院）',
            '青海大学附属医院（青海大学医学院附属医院）',
            '青海红十字医院（青海省监狱管理局中心医院）',
            '青海省藏医院',
            '青海省第四人民医院（青海省传染病医院）',
            '青海省妇女儿童医院（青海省妇产儿童医院，青海省儿童医院）',
            '青海省妇幼保健院',
            '青海省人民医院',
            '青海省心血管病专科医院',
            '青海省中医院',
            '中国人民解放军第四医院',
            '宁夏回族自治区人民医院',
            '宁夏医科大学总医院',
            '新疆维吾尔自治区人民医院',
            '山西医科大学附属太钢总医院',
            '太原市中心医院',
            '武警山西总队医院',
            '呼和浩特市第一医院',
            '内蒙古医科大学附属人民医院',
            '武警内蒙古总队医院',
            '黑龙江省农垦总医院〓黑龙江省第二肿瘤医院',
            '武汉市普仁医院',
            '贵阳市第二人民医院〓贵阳脑科医院=金阳医院',
            '甘肃省铁路中心医院〓甘肃省第二人民医院',
            '甘肃省肿瘤医院〓甘肃省医学科学研究院',
            '兰州石化总医院（兰州大学附属天浩医院）',
            '青海省第五人民医院(原西宁铁路医院)',
            '西宁市第一人民医院',
            '甘肃中医学院附属医院',
            '福建省立医院南院',
            '西宁市第三人民医院（西宁钢厂职工医院）',
            '沈阳军区总医院附属北方医院',
            '中一东北国际医院有限公司',
            '复旦大学附属中山医院厦门医院',
            '重庆市巴南区人民医院',
            '成都市青羊区人民医院',
            '辽宁中医药大学附属第四医院(辽宁中医学院附属医院中西医结合医院)',
            '海南省肿瘤医院',
            '安徽省第二人民医院',
            '重庆市中医骨科医院',
            '北京朝阳医院集团燕郊二三医院',
            '香河县气管炎哮喘医院',
            '古交矿区总医院',
            '清徐县人民医院',
            '阳曲县中医医院',
            '五常市人民医院',
            '徐州医学院附属医院西院',
            '南通市中西医结合医院〓南通市口腔医院',
            '启东市第二人民医院',
            '盐城市盐阜医院',
            '盐城市协和康复医院',
            '中医院南分院',
            '盐城市广济医院',
            '盐城迎宾外科医院',
            '妇保院开发区分院',
            '口腔医院沙井头',
            '盐城市机关医院',
            '盐城同洲手外科医院',
            '建湖县疾病预防控制中心',
            '泰兴市第三人民医院',
            '泰州市高港中医院',
            '瑞安市红十字医院',
            '江西华仁手足外科医院',
            '青岛市红岛人民医院',
            '桓台县起凤整骨医院',
            '淄博市中西医结合医院',
            '莱州市第二人民医院',
            '蓬莱同步骨科医院',
            '高密市姜庄镇卫生院',
            '潍坊同心医院',
            '山东潍城经济开发区人民医院',
            '苍山县妇幼保健院',
            '费县第二人民医院',
            '临沭县妇幼保健院',
            '蒙阴县妇幼保健院',
            '平邑县妇幼保健院',
            '郯城县第二人民医院',
            '郯城县妇幼保健院',
            '沂南县妇幼保健院',
            '沂南县攀峰骨科医院',
            '沂水县妇幼保健站',
            '沂水县中医院',
            '华仁医院〓河南省中医研究院附属癫痫病医院',
            '郑州大学医院',
            '郑州市颈肩腰腿痛医院',
            '骑士重庆专科总医院',
            '重庆城口县人民医院',
            '重庆城口县中医院',
            '重庆大学医院',
            '重庆市长城医院',
            '重庆市大渡口区人民医院',
            '重庆协和医院',
            '彭水县妇幼保健院',
            '铜梁县妇幼保健院',
            '巫山县妇幼保健院',
            '秀山县妇幼保健院',
            '重庆大足县妇幼保健院',
            '重庆大足县中医院',
            '重庆奉节县妇幼保健院',
            '重庆开县妇幼保健院',
            '重庆梁平县妇幼保健院',
            '重庆潼南县妇幼保健院',
            '云阳县妇幼保健院',
            '重庆市高新区人民医院',
            '重庆格林医院',
            '彭州市第二人民医院',
            '攀钢集团成都钢铁有限责任公司青白江医院',
            '安宁市妇幼保健院',
            '安宁市中医院',
            '呈贡县中医院',
            '晋宁县妇幼保健院',
            '昆明市东川区第二人民医院',
            '昆明市东川区妇幼保健院',
            '昆明市东川区精神病院',
            '昆明市东川区中医院',
            '昆明市经开人民医院',
            '昆明市精神病院',
            '昆明市西山区中医院',
            '云南省传染病专科医院（昆明铁路局精神病结核病防治院）',
            '禄劝县中医院',
            '路南县人民医院',
            '寻甸县中医院',
            '云南北方光学电子集团有限公司医院（云光医院）',
            '云南省海口磷矿职工医院',
            '禄劝忠爱医院',
            '云南省精神病院〓云南省精神卫生中心',
            '云南省康复医院',
            '昆明医学院第二附属医院石林天奇医院',
            '云南磷化集团中心医院',
            '米泉县中医院',
            '爱德堡医院',
            '灵寿县中西医结合医院',
            '晋州市妇幼保健院',
            '晋州市医院',
            '晋州市中医院',
            '井陉矿务局医院',
            '井陉县中医院',
            '空军获鹿医院',
            '灵寿县医院',
            '栾城县精神病医院',
            '栾城县中医院',
            '平山县中医院',
            '深泽县中医院',
            '石家庄肾病医院',
            '石家庄市糖尿病医院',
            '石家庄市装甲兵医院',
            '石家庄现代女子医院',
            '石家庄协和(男科)医院',
            '石家庄眼科医院',
            '石家庄燕赵医院',
            '石家庄友谊医院〓石家庄市郊区医院',
            '石家庄再生障碍性贫血病医院',
            '无极县医院',
            '无极县中医院',
            '辛集市第二医院',
            '辛集市第一医院',
            '辛集市妇幼保健院',
            '辛集市中医院',
            '新乐市医院',
            '新乐市中医院',
            '行唐县人民医院',
            '行唐县中医院',
            '元氏县医院',
            '元氏县中医院',
            '赞皇县妇幼保健院',
            '赞皇县医院',
            '赞皇县中医院',
            '赵县人民医院',
            '赵县中医院',
            '正定县人民医院',
            '正定县中医院',
            '中国人民解放军第六四-０工厂职工医院',
            '霸州市第二医院',
            '霸州市中医院',
            '大厂回族自治县人民医院',
            '大厂回族自治县医院',
            '大城县医院',
            '大城县中医院',
            '东杉医院',
            '固安县人民医院',
            '固安县医院',
            '固安县中医院',
            '华北石油廊坊矿区第一医院',
            '廊坊红十字骨伤科医院',
            '廊坊洪昌医院',
            '廊坊利康医院',
            '廊坊市安次区医院',
            '三河市医院',
            '三河市中医院',
            '文安县医院',
            '文安县中医院',
            '香河县医院',
            '燕郊人民医院',
            '古交市人民医院(原古交市妇幼保健院)',
            '山西焦煤集团公司第二职工医院',
            '阳曲县人民医院',
            '右玉县人民医院',
            '山西省活血化瘀研究所〓山西省中西医结合妇科医院',
            '太原钢铁公司迎新街医院',
            '太原市第十三冶金建设公司职工医院',
            '太原市类风湿病医院',
            '山西华晋骨科医院',
            '呼和浩特市二轻医院',
            '呼和浩特市回民医院',
            '呼和浩特市口腔医院',
            '呼和浩特市新城区医院',
            '法库县第一医院〓法库县中心医院',
            '沈阳煤业(集团)公司总医院〓沈阳市益民医院',
            '沈阳市新城子区医院（沈北新区中心医院）',
            '新民市人民医院',
            '新民市中医院〓新民市东城社区卫生服务中心',
            '沈阳新民同生医院',
            '长春市第六医院',
            '德惠市人民医院',
            '德惠市中医院',
            '吉林大学第三医院分院(中日联谊三部)',
            '九台市人民医院',
            '九台市中医院',
            '农安县人民医院',
            '舒兰矿务局营城煤矿职工医院',
            '榆树市医院',
            '榆树市中医院',
            '阿城市人民医院',
            '阿城市中医院',
            '宾县人民医院',
            '宾县中医院',
            '方正县中医院',
            '哈尔滨市呼兰区中医院',
            '哈尔滨市太平区人民医院',
            '哈尔滨铁路分局哈尔滨医院',
            '哈尔滨铁路局结核病医院〓哈尔滨铁路局肿瘤医院',
            '黑龙江省松滨监狱医院',
            '尚志市妇幼保健院',
            '五常市中医院',
            '亚布力镇中心卫生院（亚布力镇人民医院）',
            '大屯煤电（集团）有限责任公司职工中心医院',
            '沛县华佗医院',
            '沛县中医院',
            '邳州市人民医院',
            '邳州市中医院',
            '睢宁县人民医院',
            '铜山县人民医院',
            '新沂市人民医院',
            '新沂市中医医院',
            '徐州丰县人民医院',
            '海安县中医院',
            '海门市人民医院',
            '海门市中医院',
            '启东市人民医院',
            '启东市中医院',
            '淮安市中山医院',
            '如东县人民医院',
            '如东县中医院',
            '如皋市人民医院',
            '如皋市中医院',
            '通州市人民医院',
            '通州市中医院',
            '东海县中医院',
            '赣榆县人民医院',
            '赣榆县中医院',
            '灌南县第二人民医院',
            '灌南县人民医院',
            '灌南县中医院',
            '灌云县人民医院',
            '灌云县仁济医院',
            '连云港长寿医院(原连云市皮肤病防治所)',
            '连云港市第三人民医院〓连云港市妇幼保健院',
            '连云港市东方医院〓连云港市红十字医院',
            '连云港市新浦区人民医院',
            '连云港市云台区人民医院',
            '新浦区眼科医院',
            '洪泽县人民医院',
            '淮安市楚州医院〓淮安市肿瘤医院',
            '淮安市楚州中医院',
            '淮安市妇幼保健院',
            '淮安市中医医院',
            '金湖县人民医院',
            '涟水县人民医院',
            '盱眙县人民医院',
            '盱眙县中医院',
            '滨海县人民医院',
            '滨海县中医院',
            '大丰市人民医院',
            '大丰市中医院',
            '东南大学医学院附属盐城医院〓盐城市第三人民医院',
            '东台市第三人民医院',
            '东台市中医院',
            '阜宁县人民医院',
            '阜宁县中医院',
            '建湖县人民医院',
            '建湖县中医院',
            '江苏省农垦肿瘤医院',
            '南通大学附属东台医院〓东台市人民医院',
            '射阳县人民医院',
            '射阳县新洋农场医院',
            '射阳县中医院',
            '响水县人民医院',
            '盐城慈航医院(原盐城市城区人民医院)',
            '盐城市第四人民医院〓盐城市精神病防治院',
            '盐城市妇幼保健院',
            '三院一分院',
            '建湖县慈航医院',
            '泰兴市人民医院',
            '泰州市第二人民医院(姜堰市人民医院)',
            '姜堰市中医院',
            '靖江市人民医院',
            '靖江市中医院',
            '泰兴市中医院',
            '泰州市第四人民医院',
            '兴化市人民医院',
            '兴化市中医院',
            '苍南县第二人民医院(原苍南县龙港医院)',
            '永嘉县中医院',
            '苍南县人民医院',
            '平阳县人民医院',
            '泰顺县人民医院',
            '温州市第五人民医院',
            '温州市东瓯医院',
            '温州手足外科医院',
            '文成县人民医院',
            '永嘉县人民医院',
            '海盐县人民医院',
            '嘉兴市中医医院',
            '平湖市第一人民医院',
            '海宁康华医院',
            '安徽省康复医院〓安徽省立医院分院',
            '肥西县人民医院',
            '肥西县中医院',
            '巢湖市第二人民医院〓合肥市第八人民医院',
            '安徽医科大学附属巢湖医院（巢湖市第一人民医院）',
            '庐江县人民医院',
            '长乐市医院',
            '长乐市中医院',
            '福清市融强医院',
            '福清市医院',
            '福州市马尾区医院〓福州马江医院',
            '连江县中医院',
            '罗源县中医院',
            '闽清县医院',
            '平潭县医院',
            '平潭县中医院',
            '中国人民解放军第73301部队医院',
            '厦门市第一医院杏林院区',
            '厦门市同安区中医医院',
            '安义县人民医院',
            '进贤县人民医院',
            '南昌县人民医院',
            '南昌县中医院',
            '新建县人民医院',
            '新建县中医医院',
            '济南市第五人民医院北院区',
            '济南市精神病院',
            '济南市口腔医院',
            '济阳县人民医院',
            '济阳县中医院',
            '平阴县人民医院',
            '商河县中医医院',
            '章丘市人民医院',
            '章丘市中医医院',
            '即墨市人民医院',
            '即墨市中医院',
            '青岛市黄岛区第二人民医院',
            '青岛市黄岛区第二中医医院',
            '莱西市市立医院',
            '莱西市皮肤病医院',
            '莱西市人民医院',
            '莱西市中医医院',
            '平度市第二人民医院',
            '平度市第三人民医院',
            '平度市人民医院',
            '平度市中医院',
            '黄岛区中心医院',
            '青岛市市北区人民医院',
            '淄博市妇幼保健医院高青院区',
            '淄博市中心医院高青分院',
            '桓台县妇幼保健院',
            '齐鲁医院桓台分院',
            '淄博市临淄区妇幼保健医院',
            '北大医疗鲁中医院',
            '沂源县人民医院',
            '沂源县中医医院',
            '长岛县人民医院',
            '海阳市人民医院',
            '海阳市中医医院',
            '莱州市人民医院',
            '龙口市第二人民医院',
            '龙口市人民医院',
            '龙口市中医医院',
            '蓬莱市人民医院',
            '栖霞市妇幼保健院',
            '栖霞市中医医院',
            '烟台市牟平区中医医院',
            '烟台市桃村中心医院(原栖霞市第二人民医院)',
            '招远市人民医院',
            '中国人民解放军第四0五医院',
            '中国石化集团第十建设公司职工医院（位置有误，勿选取）',
            '莱阳市中医医院',
            '淄博市张店区口腔病医院',
            '蓬莱市中医医院',
            '安丘市人民医院',
            '昌乐县中医院',
            '昌邑市妇幼保健院',
            '昌邑市人民医院',
            '昌邑市中医院',
            '高密市妇幼保健院',
            '高密市人民医院',
            '临朐县中医院〓临朐县妇幼保健站',
            '青州市人民医院',
            '青州市中医院',
            '寿光市人民医院',
            '寿光市中医医院',
            '潍坊滨海经济技术开发区人民医院',
            '潍坊寒亭区人民医院',
            '潍坊市坊子区人民医院',
            '潍坊口腔医院',
            '潍坊市脑科医院',
            '潍坊市市立医院',
            '诸城市人民医院',
            '嘉祥县中医院',
            '金乡县人民医院〓济宁医学院附属金乡医院',
            '梁山县中医院',
            '曲阜市人民医院',
            '济宁医学院曲阜医院〓曲阜市中医院',
            '泗水县人民医院',
            '微山县人民医院〓微山县红十字会医院',
            '汶上县人民医院',
            '汶上县中医院',
            '兖矿集团公司第二医院',
            '兖矿集团总公司兴隆庄医院',
            '兖州市第二人民医院=兖州中医院',
            '兖州市人民医院',
            '兖州市中医院',
            '兖州铁路医院',
            '邹城市妇幼保健院',
            '邹城市协和中医院',
            '平邑县人民医院',
            '苍山县中医院',
            '费县妇幼保健院',
            '费县人民医院',
            '费县中医院',
            '莒南县人民医院',
            '莒南县中医院',
            '临沭县人民医院',
            '临沭县中医院',
            '临沂市监狱医院',
            '临沂罗庄中心医院',
            '临沂市保生堂医院',
            '临沂市肝胆病医院',
            '临沂市高新区人民医院',
            '临沂市河东区人民医院',
            '临沂市红旗医院',
            '临沂市交通医院',
            '临沂市精神病院〓临沂市第四人民医院',
            '临沂市凯旋医院',
            '临沂市兰山区第二人民医院',
            '临沂市兰山区第一人民医院',
            '临沂市罗庄区人民医院',
            '临沂市沂蒙医院',
            '临沂医专附属医院(原临沂铁路医院)',
            '蒙阴县第二人民医院',
            '蒙阴县人民医院',
            '蒙阴县中医院',
            '山东省鲁南眼科医院〓临沂医专附属眼科医院',
            '郯城县第一人民医院',
            '郯城县中医院',
            '沂南县人民医院',
            '临沂临港经济开发区人民医院',
            '登封市妇幼保健院〓登封市第二人民医院',
            '登封市人民医院',
            '登封市中医院',
            '巩义市人民医院',
            '巩义市中医院',
            '河南省煤炭总医院〓河南省煤炭职业病防治院',
            '新密市第一人民医院',
            '新密市妇幼保健院',
            '新密市红十字会中风专科医院',
            '新密市中医院',
            '新郑市人民医院',
            '新郑市中医院',
            '荥阳市人民医院',
            '郑煤集团总医院',
            '郑州市第九人民医院（郑州铁路分局医院）',
            '郑州中医骨伤病医院',
            '中牟县第一人民医院',
            '中牟县中医院',
            '荥阳市瑞龙医院',
            '新密市新华医院',
            '郑州仁和老年病医院',
            '郑州市惠济区人民医院',
            '荥阳市第二人民医院',
            '华中科技大学同济医学院附属协和西院',
            '武汉市第十三医院〓蔡甸区人民医院',
            '华中科技大学同济医学院附属普爱医院',
            '武汉市东西湖区人民医院',
            '武汉市黄陂区人民医院',
            '武汉市黄陂区中医院',
            '武汉市江夏区中医院',
            '武汉市新洲区第二人民医院',
            '武汉市新洲区人民医院',
            '汉口医院',
            '武昌医院',
            '佛山市第四人民医院〓佛山市结核病防治所',
            '佛山市南海区官窑医院〓佛山市南海经济开发区人民医院官窑分院',
            '佛山市禅城区南庄医院〓佛山市第一人民医院禅城医院',
            '佛山市第三人民医院',
            '佛山市高明区妇幼保健院〓佛山市高明区妇女儿童医院',
            '佛山市高明区中医院',
            '佛山市南海区丹灶医院〓佛山市南海区第八人民医院',
            '佛山市南海区九江医院〓佛山市南海区第九人民医院',
            '佛山市南海区小塘医院〓佛山市南海经济开发区人民医院小塘分院',
            '佛山市顺德医院〓佛山市顺德区中西医结合医院',
            '顺德区中医院（仅限骨伤科）',
            '宾阳县妇幼保健院',
            '宾阳县中医院',
            '隆安县人民医院',
            '马山县人民医院',
            '马山县中医院',
            '南宁市第九人民医院',
            '上林县人民医院',
            '定安县人民医院',
            '安定县人民医院',
            '海口市二轻医院',
            '海口市结核病防治所',
            '海口市秀英区妇幼保健站',
            '海口市振东区妇幼保健所',
            '海口市职业病防治所',
            '海南港岛联合中医肿瘤医院',
            '海南骨科医院',
            '海南现代女子儿童医院',
            '中国人民解放军海军南航医院',
            '中国人民解放军海军四二四医院',
            '昌江黎族自治县人民医院',
            '澄迈县妇幼保健院',
            '澄迈县人民医院',
            '海南省国营和岭农场医院',
            '乐东黎族自治县人民医院',
            '三亚市妇幼保健院',
            '昌江县中医院=昌江黎族自治县中医院',
            '儋州市第二人民医院',
            '东方市人民医院',
            '东方市中西医结合医院',
            '东方市中医院',
            '海南省国营晨星农场医院',
            '海南省国营红岭农场医院',
            '海南省国营黄岭农场医院',
            '海南省国营加来农场医院',
            '海南省国营蓝洋农场医院',
            '海南省国营龙江农场医院',
            '海南省国营西流农场医院',
            '海南省铁路总公司铁路医院',
            '海南铁矿职工医院',
            '万宁市妇幼保健站',
            '万宁市中医院',
            '五指山市冲山医院',
            '五指山市中医院',
            '兴隆华侨农场医院',
            '璧山县妇幼保健院',
            '璧山区人民医院',
            '涪陵区人民医院',
            '合川市妇幼保健院',
            '中国石化总公司四川维尼纶厂职工医院',
            '重庆合川市中医院',
            '重庆江津市妇幼保健院',
            '重庆江津市工人医院',
            '重庆市南川区人民医院',
            '重庆市长寿区妇幼保健院',
            '重庆市长寿区人民医院',
            '重庆市涪陵区妇幼保健院',
            '重庆市红十字会医院（江北区人民医院）',
            '重庆市市中区中医骨科医院',
            '重庆市万州区人民医院',
            '重庆永川市妇幼保健院',
            '彭水县中医院',
            '荣昌县妇幼保健院',
            '石柱县中医院',
            '秀山县中医院',
            '丰都县人民医院',
            '奉节县中医院',
            '重庆开县人民医院',
            '重庆开县中医院',
            '荣昌县中医院',
            '重庆市綦江齿轮厂职工医院',
            '巫山县人民医院',
            '巫山县中医院',
            '重庆巫溪县人民医院',
            '重庆巫溪县中医医院',
            '云阳县人民医院',
            '忠县人民医院',
            '忠县中医院',
            '成都市第五人民医院',
            '成都市儿童医院',
            '成都市龙泉驿区第一人民医院',
            '成都市青白江区人民医院',
            '成都市新都区第二人民医院',
            '崇州市妇幼保健院',
            '崇州市人民医院',
            '金堂县第一人民医院',
            '彭州市人民医院',
            '彭州市中医院',
            '成都市郫都区人民医院',
            '邛崃市第三人民医院（邛崃市中医院）',
            '邛崃市医疗中心医院（邛崃市人民医院）',
            '四川省复员退伍军人医院',
            '四川省监狱管理局中心医院',
            '四川省石油管理局总医院',
            '四川石油管理局总医院',
            '贵阳市第六人民医院(原贵阳铁路医院)',
            '贵州医科大学附属白云医院',
            '开阳县人民医院',
            '息烽县人民医院',
            '息烽县中医院',
            '安宁市人民医院',
            '呈贡县人民医院',
            '富民县人民医院',
            '禄劝县人民医院',
            '石林县人民医院',
            '嵩明县人民医院',
            '嵩明县中医院',
            '宜良县人民医院',
            '宜良县中医院',
            '当雄县人民医院',
            '西藏自治区第二人民医院',
            '中国人民武警部队西藏总队医院',
            '甘肃省建筑职工医院',
            '甘肃省康复中心医院',
            '甘肃省西北民族学院附属医院',
            '兰州红十字康乐医院',
            '兰州炼油化工职工医院',
            '兰州石油化工机器总厂职工医院',
            '兰州市城关区第二人民医院',
            '兰州市城关区第三人民医院',
            '兰州市红古区人民医院',
            '兰州市口腔医院',
            '兰州市窑街煤电公司医院',
            '兰州炭素工业公司职工医院',
            '兰州西固区妇幼保健院',
            '永登县人民医院',
            '永登县中医院',
            '榆中县第一人民医院',
            '榆中县中医院',
            '中国核工业总公司五零四厂职工医院',
            '大通县第一人民医院',
            '湟源县人民医院',
            '湟源县中医院',
            '湟中县藏医院',
            '湟中县第二人民医院',
            '湟中县第一人民医院',
            '湟中县中医院',
            '青海大通红十字医院(原大通矿务局职工医院)',
            '青海省兴华医院',
            '青海石油勘探局西宁慢性病医院',
            '武警青海总队医院',
            '西川中心人民医院',
            '西宁市城北区中医院',
            '西宁市妇幼保健中心',
            '青海仁济医院',
            '贺兰县人民医院',
            '灵武市人民医院',
            '灵武市中医医院',
            '宁夏宁安医院(原宁夏精神卫生中心)',
            '永宁县人民医院',
            '永宁县中医院',
            '新疆八一钢铁公司医院（八钢医院）',
            '长城心脑血管病医院',
            '高邑县医院',
            '高邑县中医院',
            '藁城市康复医院',
            '藁城市廉州医院',
            '藁城市糖尿病医院',
            '河北红十字会博爱医院',
            '河北红十字石家庄中西医结合医院',
            '河北汇龙中西医结合医院',
            '河北省地方病防治所',
            '河北省二监狱新生医院',
            '河北省妇幼保健中心',
            '河北省海联中西医结合医院',
            '河北省华福医院',
            '河北省新乐荣军精神病医院',
            '河北省肢残康复中心',
            '河北省职业病防治所',
            '河北水利医院',
            '河北中医糖尿病治疗中心',
            '晋州市偏瘫医院',
            '井陉县妇幼保健院',
            '平山县法医医院',
            '平山县妇幼保健院',
            '平山县古月医院',
            '平山县人民医院（平山县医院）',
            '无极血康医院',
            '永清县中医医院',
            '廊坊市广阳区人民医院',
            '娄烦县人民医院',
            '潞城市人民医院',
            '清徐县第二人民医院',
            '太原市杏花岭区中医医院',
            '太原市北城区中心医院',
            '太原市康复医院〓太原市盲人按摩医院',
            '太原市杏花岭区中医院',
            '和林格尔县人民医院',
            '呼和浩特市赛罕区医院',
            '呼和浩特市土左旗医院',
            '呼和浩特市邮电医院',
            '呼和浩特市玉泉区红十字医院',
            '内蒙航天医院',
            '清水河县医院',
            '仕奇集团职工医院',
            '土默特左旗人民医院',
            '托克托县南坪医院',
            '托克托县医院',
            '武川县医院',
            '康平县人民医院',
            '九台市第二人民医院',
            '九台市第三人民医院',
            '农安县中医医院',
            '首钢吉林柴油机厂职工医院〓吉林华康老年病医院',
            '巴彦县妇幼保健站',
            '巴彦县人民医院',
            '巴彦中医院',
            '方正林业局职工医院',
            '方正县人民医院',
            '哈尔滨第一机械制造厂职工医院',
            '哈尔滨龙江电工厂医院',
            '哈尔滨煤炭工业公司职工医院（中煤龙化哈尔滨实业有限公司职工医院）',
            '哈尔滨汽轮厂医院',
            '哈尔滨市呼兰区第二人民医院',
            '哈尔滨市呼兰区第一人民医院',
            '哈尔滨市太平区中西医结合医院',
            '哈尔滨水泥厂医院',
            '哈尔滨松江电机厂职工医院',
            '清河林区人民医院（清河林业局职工医院）',
            '黑龙江兴隆林业局职工第一医院',
            '木兰县第二人民医院',
            '木兰县人民医院',
            '木兰县中医院',
            '尚志市人民医院',
            '双城市骨伤科医院',
            '双城市人民医院',
            '通河县人民医院',
            '通河县中医院',
            '延寿县人民医院',
            '延寿县中医院',
            '依兰县人民医院',
            '依兰县中医院',
            '中国第一汽车集团哈尔滨轻型车厂职工医院',
            '巴彦县第二人民医院',
            '睢宁县中医院',
            '铜山县中医院',
            '徐州丰县中医院',
            '徐州仁慈手外科医院',
            '徐州市彭城人民医院',
            '徐州铁路分局新沂铁路医院',
            '南通港口医院',
            '如皋市尘洁医院',
            '通州市第三人民医院',
            '灌云县中医院',
            '海州区人民医院',
            '江苏省东辛集团职工医院',
            '江苏省盐业公司总医院',
            '连云港海港医院',
            '连云港市第四人民医院',
            '连云港市康复医院',
            '新浦区第三人民医院',
            '洪泽县中医院',
            '淮安市第三人民医院〓淮安市脑科医院',
            '淮安市第四人民医院(原淮安市传染病防治院)',
            '涟水县中医医院',
            '大丰市第二人民医院',
            '建湖县第二人民医院',
            '江苏省黄海农场医院',
            '江苏省银包盐业有限公司医院',
            '响水县中医院',
            '盐城市口腔医院',
            '建阳眼科医院',
            '靖江市第二人民医院',
            '泰兴市第二人民医院',
            '泰州市第三人民医院(泰州市高港人民医院)',
            '泰州市中医院',
            '兴化市第三人民医院',
            '苍南县中医院〓上海中山医院苍南分院',
            '洞头县人民医院',
            '乐清市中医院',
            '瑞安市第五人民医院〓瑞安市精神病院',
            '瑞安市妇幼保健院',
            '浙江省温州矾矿医院',
            '海宁市第三人民医院（浙江省人民医院海宁医院）',
            '海宁市盐官精神病院（海宁市第四人民医院）',
            '海宁市妇幼保健院',
            '海宁市中医院',
            '海盐县妇幼保健院',
            '海盐县沈荡医院',
            '海盐县牙病防治所',
            '海盐县中医院',
            '嘉善县第二人民医院',
            '嘉善县妇幼保健所',
            '嘉善县职工医院',
            '嘉善县中医医院',
            '嘉兴华普东方口腔医院',
            '嘉兴市第二医院清河分院',
            '嘉兴市康慈医院',
            '嘉兴市王店人民医院',
            '嘉兴市秀洲区新塍医院',
            '嘉兴市秀洲区妇幼保健所',
            '嘉兴曙光中西医结合医院',
            '民丰集团公司职工医院',
            '平湖市第二人民医院',
            '平湖市妇幼保健所',
            '平湖市红十字会医院',
            '平湖市眼科医院',
            '平湖市中医院',
            '秦山核电医院',
            '桐乡市第二人民医院',
            '桐乡市第三人民医院',
            '桐乡市妇幼保健院',
            '桐乡市皮肤病防治院',
            '桐乡市第四人民医院',
            '桐乡市中医医院',
            '浙江省荣军医院（嘉兴市第三医院）',
            '中国核工业第二二建筑公司二工程公司职工医院',
            '中国核工业第二三建筑公司三工程公司职工医院',
            '中国核工业二四公司核电工程公司工地医院',
            '长丰县人民医院',
            '肥东县人民医院',
            '肥东县中医医院',
            '闽侯县医院',
            '闽清县六都医院',
            '永泰县中医院',
            '江西医学院向塘医院(原向塘铁路医院)',
            '进贤县中医院',
            '商河县人民医院',
            '中国建筑第八工程局总医院',
            '桓台县中医院',
            '莱阳市第二人民医院',
            '莱阳市第一人民医院',
            '青州市妇幼保健院',
            '青州市立医院',
            '潍坊市第四人民医院〓潍坊肿瘤医院',
            '嘉祥县人民医院',
            '金乡县中医院',
            '泗水县中医院',
            '微山县中医院',
            '邹城市红十字会急救中心',
            '武警8680部队医院',
            '新密市第三人民医院',
            '新郑市第二人民医院',
            '郑州铁路分局焦作医院',
            '中原油田医院第七分院',
            '中原油田总医院第十分院',
            '新郑市第三人民医院',
            '新密市郑煤集团矿务局医院',
            '武汉市汉南区人民医院',
            '宾阳县人民医院',
            '南宁地区复退军人医院〓南宁地区复退军人精神病医院',
            '横县人民医院',
            '白沙黎族自治县人民医院',
            '保亭黎族苗族自治县人民医院',
            '昌江黎族自治县中医院',
            '乐东黎族自治县中医院',
            '陵水黎族自治县人民医院',
            '琼中黎族苗族自治县人民医院',
            '三亚华侨医院',
            '三亚市琼南眼科医院',
            '保亭县医院',
            '儋州市中医院',
            '临高县中医院',
            '文昌市中医院',
            '南川市妇幼保健院',
            '中国船舶工业总公司六五二医院',
            '重庆合川市中西医结合医院',
            '重庆南川市第二人民医院',
            '重庆市长寿区中医院',
            '重庆市涪陵建峰医院',
            '重庆市涪陵区第二人民医院',
            '重庆市涪陵区中医院',
            '重庆市九龙坡区人民医院',
            '重庆市双桥区人民医院',
            '重庆市万盛区妇幼保健院',
            '重庆市万盛区中医院',
            '重庆市万州区第四人民医院',
            '重庆市万州区中西医结合医院(原重庆市万州区第三中医院)',
            '彭水县人民医院',
            '石柱县人民医院',
            '秀山县人民医院',
            '忠县妇幼保健院',
            '重庆梁平县中医院',
            '重庆綦江县中医院',
            '重庆云阳县中医院',
            '阿坝州林业中心医院',
            '成都市温江区妇幼保健院',
            '成都市老年病医院（成都市第二干部疗养院）',
            '成都市慢性病医院',
            '成都市温江区人民医院',
            '崇州二医院',
            '崇州市骨伤矫形外科医院',
            '大邑县人民医院',
            '都江堰市第二人民医院',
            '都江堰市精神病医院',
            '金堂县第二人民医院',
            '金堂县中医院',
            '成都市郫都区第二人民医院',
            '蒲江县人民医院',
            '双流县第一人民医院',
            '西南兵工成都医院',
            '新津县人民医院',
            '开阳县中西医结合医院',
            '修文县人民医院',
            '晋宁县第二人民医院',
            '晋宁县人民医院',
            '晋宁县中医院',
            '石林县中医院',
            '寻甸县第一人民医院',
            '皋兰县人民医院',
            '兰州市安宁区人民医院',
            '格尔木铁路医院',
            '西宁市回族医院',
            '阿城市妇幼保健院',
            '哈尔滨市社会福利院伤残康复医院',
            '双城市妇幼保健站',
            '双城市中医院',
            '依兰县妇幼保健院',
            '铜山县传染病医院',
            '苍南县第三人民医院',
            '乐清市第二人民医院',
            '乐清市第三人民医院',
            '乐清市妇幼保健院',
            '平阳县中医院',
            '瑞安市第二人民医院〓瑞安市仙降医院',
            '瑞安市第三人民医院',
            '泰顺县第二人民医院',
            '文成县中医医院',
            '胶州市第三人民医院',
            '胶州市心理康复医院',
            '高青县中医院',
            '四川省新源煤矿医院〓大邑县骨科医院',
            '中国人民解放军四六七医院',
            '内蒙古自治区红十字会呼和浩特朝聚眼科医院',
            '黑龙江省第四医院=黑龙江省传染病防治院=黑龙江省结核病防治院',
            '市第一人民医院五官科医院',
            '中国医药城医院(泰州普济医院)',
            '泰州市妇幼保健院',
            '浙江新安国际医院',
            '龙口市南山医院',
            '潍坊市第二人民医院',
            '潍坊市医学院附属医院',
            '郑州民生医院',
            '河南省弘大心血管病医院',
            '陆军军医大学西南医院',
            '贵州华夏骨科医院',
            '中国人民解放军第五三三医院',
            '昆明骨科医院',
            '云南骨科医院',
            '贵州医科大学附属乌当医院',
            '石家庄平安医院(原石家庄肿瘤医院)',
            '中国人民解放军二五六医院',
            '京东中美医院',
            '廊坊市人民医院',
            '廊坊市中医院',
            '中国石油天然气总公司中心医院',
            '山西博爱医院',
            '呼和浩特市第三医院(原呼和浩特市钢铁职工医院)',
            '呼和浩特市复兴医院',
            '内蒙古自治区精神卫生中心',
            '沈阳市传染病院',
            '吉林省结核病医院',
            '哈尔滨市动力区护理医院〓哈尔滨市动力区人民医院',
            '哈尔滨市神经精神医院',
            '黑龙江省康复医院',
            '南通大学第二附属医院〓南通市第一人民医院',
            '南通大学附属医院',
            '南通市第二人民医院',
            '南通市第三人民医院',
            '南通市中医院',
            '南通市肿瘤医院',
            '连云港市第一人民医院',
            '盐城市第一人民医院〓南通医学院第四附属医院',
            '嘉兴市第二医院(嘉兴学院附属第二医院)',
            '嘉兴市第一医院（嘉兴学院附属第一医院）',
            '嘉兴市妇幼保健院',
            '武警浙江总队嘉兴医院（嘉兴江南医院）',
            '厦门市第一医院',
            '厦门市心血管病医院',
            '江西省胸科医院（江西省第三人民医院）',
            '济南明水眼科医院',
            '山东省妇幼保健院〓山东省妇产医院',
            '淄博市中心医院北院区',
            '烟台市妇幼保健院',
            '莱州市中医医院',
            '潍坊市第三人民医院(原潍坊市精神卫生中心)',
            '潍坊市人民医院',
            '潍坊市中医院',
            '中国人民解放军第八十九医院',
            '临沂市妇幼保健院〓临沂市妇女儿童医院',
            '临沂市人民医院',
            '临沂市中医院',
            '临沂市肿瘤医院',
            '平邑县中医院',
            '中国人民解放军第一五三医院',
            '佛山市中医院',
            '定安县中医院',
            '琼海市中医院〓琼海市中西医结合医院',
            '涪陵区中心医院',
            '江津区中心医院（江津市人民医院）',
            '重庆三峡中心医院',
            '陆军军医大学大坪医院',
            '重庆市妇幼保健院',
            '重庆市九龙坡区中医院',
            '重庆市南岸区人民医院',
            '陆军军医大学新桥医院',
            '成都市妇女儿童医院（删除，该医院已被合并）',
            '成都市妇幼保健院（已更名，请在定点医院中选取“成都市妇女儿童中心医院”）',
            '成都上锦南府医院（四川大学华西医院上锦院区）',
            '武警云南总队医院',
            '西藏自治区藏医院',
            '青海省第二人民医院',
            '青海省第三人民医院',
            '青海省康复医院',
            '阜外华中心血管病医院(河南省人民医院心脏中心)',
            '中国人民解放军第二五六医院',
            '山西省精神卫生中心',
            '太原铁路分局太原铁路中心医院',
            '南通市妇幼保健院',
            '连云港市第二人民医院〓连云港市肿瘤医院',
            '连云港市中医院',
            '中国人民解放军第一四九医院',
            '淮安市第二人民医院',
            '淮安市第一人民医院',
            '盐城市中医院',
            '泰州市人民医院',
            '乐清市人民医院',
            '瑞安市人民医院',
            '瑞安市中医院',
            '海宁市人民医院',
            '嘉善县第一人民医院',
            '厦门市海沧医院',
            '厦门市第五医院',
            '复旦大学附属儿科医院厦门分院（厦门市儿童医院）',
            '胶州中心医院',
            '烟台市莱阳中心医院',
            '烟台市心理康复医院',
            '潍坊市妇幼保健院',
            '潍坊市益都中心医院',
            '兖州九一医院',
            '兖州矿务局总医院',
            '临沂市第三人民医院〓临沂市胸科医院',
            '佛山市高明区人民医院',
            '成都市天府新区人民医院',
            '都江堰市人民医院',
            '昆明市第二人民医院北市区分院',
            '昆明市东川区第一人民医院',
            '武警甘肃省总队医院',
            '中国人民解放军第二十九医院',
            '乌鲁木齐市第四人民医院',
            '东海县人民医院',
            '连江县医院',
            '云南昆钢医院（昆明市第四人民医院）',
            '安丘市妇幼保健院(安丘市妇女儿童医院)',
            '安丘市中医院',
            '奉节县人民医院',
            '合肥中铁四局集团第四医院',
            '兰陵县人民医院',
            '昌乐县人民医院',
            '甘肃中医药大学附属医院',
            '南通瑞慈医院',
            '崇州市中医院',
            '大邑望县中医院',
            '郑州市第十六人民医院（郑州大学第一附属医院集团）',
            '都江堰市红十字会医院',
            '都江堰市中医院',
            '彭州市妇幼保健院',
            '丰都县中医院',
            '梁平县人民医院',
            '垫江县人民医院',
            '高密市中医院',
            '古交市中心医院',
            '海安县人民医院〓南通医学院附属海安医院',
            '淮安市淮阴医院',
            '中国人民解放军第八二医院',
            '青岛市黄岛区第三人民医院',
            '青岛慧康医院',
            '重庆三博长安医院有限公司',
            '重庆市南桐矿务局总医院',
            '重庆市万盛经济技术开发区人民医院',
            '重庆市綦江区人民医院',
            '松藻煤电公司总医院（松藻矿务局松藻煤矿职工医院）',
            '重庆江津市第二人民医院',
            '胶州市人民医院',
            '胶州市妇幼保健院',
            '四川长城肾脏病医院',
            '成都和畅消化病医院',
            '成都西华医院',
            '解放军第452医院(空军成都医院)',
            '四川锦欣妇女儿童医院',
            '井陉县医院',
            '重庆恒生手外科医院',
            '重庆白市驿骨科医院',
            '梁山县人民医院',
            '沈阳市辽中区人民医院',
            '临朐县人民医院',
            '烟台龙矿中心医院',
            '烟台市北海医院',
            '成都市龙泉驿区中医院',
            '成都航天医院',
            '成都市龙泉驿区第二人民医院',
            '禄劝忠爱医院秀屏医院',
            '栾城县医院',
            '滨州医学院烟台附属医院=牟平区人民医院',
            '沛县人民医院',
            '成都市郫都区中医院',
            '平阴县中医医院',
            '栖霞市人民医院',
            '黔江民族医院',
            '黔江东蓝医院',
            '武隆县人民医院',
            '酉阳土家族苗族自治县人民医院',
            '重庆市黔江中心医院',
            '成都市青白江区妇幼保健院',
            '成都市青白江区中医院',
            '廊坊市第四人民医院（霸州市第一医院）',
            '河北燕达医院',
            '沙坪坝区中西医结合医院',
            '亚布力林区人民医院',
            '深泽县医院',
            '单县海吉亚医院',
            '双流县中医院',
            '桐乡市第一人民医院',
            '重庆市铜梁区中医院',
            '重庆潼南县人民医院',
            '微山湖医院',
            '潍坊眼科医院',
            '成都市温江区中医院',
            '成都市武侯区人民医院（成都市武侯区妇幼保健院）',
            '四川现代医院',
            '宁夏回族自治区第三人民医院',
            '香河县中医院',
            '厦门莲花医院莲河总院',
            '成都市新都区人民医院',
            '成都市新都区中医院',
            '新津县中医院',
            '海口市骨科与糖尿病医院',
            '海南省儿童医院',
            '沂南县中医院（沂南县人民医院南院）',
            '沂水县人民医院',
            '沂水县第二人民医院（原沂水马站人民医院）',
            '临沂市中心医院',
            '荥阳市中医院',
            '永川福华医院',
            '重庆合川市人民医院',
            '重庆大足区人民医院',
            '荣昌县人民医院',
            '重庆永川市人民医院',
            '重庆铜梁县人民医院',
            '重庆潼南县中医院',
            '重庆医科大学附属永川医院',
            '重庆永川市中医院',
            '永清县人民医院',
            '永泰县医院',
            '鱼台县人民医院',
            '邹城市人民医院',
            '重庆红岭医院',
            '诸城市中医医院',
            '天津市第二医院',
            '天津市公安医院',
            '天津市和平区中医院',
            '天津市河北区建昌医院',
            '天津市河北医院',
            '天津市红桥区中医院',
            '天津市红桥医院',
            '天津市黄河医院',
            '天津市南开区水阁医院',
            '天津市南开区中医院',
            '中国人民解放军第二七二医院',
            '中国人民解放军空军水上村医院',
            '深圳平乐骨伤科医院',
            '深圳市龙华新区人民医院',
            '深圳市福田区妇幼保健院',
            '深圳市罗湖区妇幼保健院',
            '深圳市罗湖区中医院',
            '深圳市南山妇幼保健院〓深圳市蛇口联合医院',
            '深圳市蛇口人民医院',
            '天津市和平区妇产医院',
            '天津市河东区结核病呼吸系统疾病防治院',
            '天津市红桥区妇幼保健院',
            '天津市南开区三潭医院',
            '天津市河东区常州医院',
            '天津市第二人民医院(天津市传染病医院)',
            '天津市第三医院',
            '天津市第三中心医院',
            '天津市第四医院',
            '天津市第四中心医院',
            '天津市第一中心医院',
            '天津市儿童医院',
            '天津市口腔医院',
            '天津医科大学口腔医院',
            '天津市环湖医院',
            '天津市人民医院',
            '天津市武警医学院附属医院',
            '天津市胸科医院',
            '天津市眼科医院',
            '天津市中心妇产科医院',
            '天津市中医药大学第二附属医院',
            '天津市中医药大学第一附属医院',
            '天津市中医药研究院附属医院（长征医院）',
            '天津医科大学附属肿瘤医院',
            '天津医院',
            '武警天津部队医院',
            '中国人民解放军第二五四医院',
            '中国人民解放军四六四医院',
            '中国医学科学院血液病医院',
            '深圳市妇幼保健院',
            '北京大学深圳医院',
            '广州中医药大学深圳附属医院（深圳市中医院）',
            '深圳市第二人民医院',
            '深圳市第六人民医院〓深圳市南山人民医院〓广东医学院附属南山医院',
            '深圳市第四人民医院〓深圳市福田区人民医院〓广东医学院福田医院',
            '深圳市第五人民医院〓深圳市罗湖人民医院',
            '深圳市儿童医院',
            '深圳市人民医院',
            '深圳市孙逸仙心血管医院',
            '香港大学深圳医院',
            '天津医科大学第二附属医院',
            '深圳市第九人民医院〓深圳市龙岗中心医院',
            '北京老年医院（通州）',
            '黑龙江省农垦齐齐哈尔分局中心医院',
            '大庆油田总医院集团铁人医院',
            '苏州市精神病福利院（苏州市民康医院）',
            '蚌埠创伤康复医院',
            '阜阳卫校附属医院',
            '中国空空导弹研究院洛阳二0二医院',
            '河南煤炭卫生学校附属医院',
            '南阳油田总医院（河南石油勘探局总医院）',
            '南阳市第九人民医院(原南阳铁路医院)',
            '驻马店肿瘤医院（东笃医院）',
            '岳阳市三五一七职工医院',
            '韶关市第二人民医院',
            '广东省韶钢职工医院大宝山分院',
            '韶关市皮肤病医院',
            '深圳市布吉人民医院(深圳市龙岗区第二人民医院)',
            '深圳市彩田医院',
            '深圳市南山区西丽医院',
            '深圳市宝安区中心医院（西乡人民医院）',
            '武警深圳医院',
            '汕头潮南民生医院',
            '汕头市第三人民医院(原汕头市结核病医院)',
            '汕头市金平区第一人民医院',
            '东莞市大朗医院',
            '东莞市长安医院',
            '东莞市凤岗华侨医院',
            '东莞市横沥医院',
            '东莞市虎门医院',
            '东莞市寮步医院',
            '南方医科大学广济南栅医院(东莞市南栅王少强医院)',
            '东莞市清溪医院',
            '东莞市石碣人民医院',
            '东莞市塘厦人民医院',
            '东莞市樟木头人民医院',
            '东莞市中堂医院',
            '天津市残疾儿童康复中心',
            '天津市第一医院',
            '天津市东丽区东丽医院',
            '天津医科大学总医院滨海医院',
            '天津市河北区妇幼保健院',
            '天津市河东区赤峰医院',
            '天津市河东区津东医院',
            '天津市河东区中医院',
            '天津市河西医院',
            '天津市民族医院',
            '天津市肢体残疾专科医院',
            '武警八六三0部队医院',
            '丰南市妇幼保健院',
            '华北煤炭医学院路南分院(原唐山市路南区医院)',
            '开滦(集团)有限责任公司范各庄矿业公司医院',
            '开滦(集团)有限责任公司林西矿医院',
            '开滦(集团)有限责任公司吕家坨医院',
            '开滦(集团)有限责任公司马家沟矿职工医院',
            '开滦(集团)有限责任公司钱家营矿分公司医院',
            '开滦(集团)有限责任公司唐家庄矿医院〓开滦嘉盛医院',
            '开滦(集团)有限责任公司唐家庄矿职工医院',
            '开滦(集团)有限责任公司赵各庄矿医院',
            '唐山钢铁集团有限公司医院',
            '唐山车城医院',
            '唐山开滦矿务局荆各庄矿职工医院',
            '唐山三友集团有限公司职工医院',
            '唐山市第八医院(原唐山陶瓷集团有限公司医院)',
            '唐山市第二医院（唐山市骨科医院）',
            '唐山市第九医院(原唐山市脑血管病医院)',
            '唐山市第七医院(原唐山市传染病院)',
            '唐山市第三医院',
            '唐山市第五医院(原唐山市精神康复医院)',
            '唐山市丰润区第二医院',
            '丰润区人民医院',
            '唐山市丰润区中医院',
            '唐山市古冶区医院',
            '唐山市古冶区中医院',
            '唐山市开平区医院',
            '唐山市利明医院',
            '唐山市协和医院(原唐山市卫校附属医院)',
            '唐山市新区医院',
            '唐山市眼科医院',
            '唐山铁路中心医院',
            '唐山友谊医院',
            '中国二十二冶金医院',
            '中国建筑二局职工医院',
            '中国人民解放军二五五医院',
            '唐山五官医院',
            '大同市第一人民医院',
            '大同市第二人民医院',
            '大同市第四人民医院〓大同市传染病医院',
            '大同市交通医院',
            '大同市口腔医院',
            '大同市南郊区人民医院',
            '大同市中医医院',
            '大同市第七人民医院（大同铁路中心医院）',
            '大同铁路中医院',
            '营口市第二人民医院',
            '营口市第三人民医院（营口市传染病医院）',
            '营口市第一专科医院',
            '营口市经济技术开发区中心医院',
            '营口市经济技术开发区第二人民医院(熊岳二院)',
            '吉林市江湾创伤医院',
            '吉林市第二人民医院',
            '吉林市第六人民医院',
            '吉林市儿童医院〓吉林市第七人民医院',
            '吉林市妇产医院',
            '吉林市龙潭区妇幼保健院',
            '吉林市龙潭区中医院',
            '吉林市中西医结合肛肠医院',
            '吉林市中医院',
            '吉林卫校附属医院〓吉林职工医科大学附属医院',
            '吉林造纸业股份公司职工医院',
            '第一重型机器制造厂职工医院',
            '和平机器制造厂职工医院',
            '齐齐哈尔华安医院(原黑龙江华安工业(集团)公司职工医院)',
            '齐齐哈尔建华机械厂职工医院',
            '齐齐哈尔市第二机床厂职工医院',
            '齐齐哈尔市第一机床厂职工医院',
            '齐齐哈尔铁路车辆集团医院',
            '大庆市第五医院(原大庆石化总厂职工医院)',
            '苏州市妇幼保健院',
            '苏州市广济医院',
            '苏州市吴中区木渎人民医院',
            '苏州市眼耳鼻喉科医院',
            '吴江市第一人民医院',
            '蚌埠市第二人民医院',
            '蚌埠市中医院',
            '安徽省阜阳肿瘤医院',
            '阜阳市第二人民医院(原阜阳地区传染病医院)',
            '阜阳市第三人民医院〓阜阳市中心医院(原阜阳市精神病医院)',
            '阜阳市人民医院',
            '中铁四局集团第二医院',
            '莆田市秀屿医院(原莆田市秀屿区湄洲湾北岸医院)',
            '莆田学院附属医院',
            '国立华侨大学医院',
            '晋江市医院（爱国楼医院）',
            '晋江市中医院',
            '泉州市东南医院',
            '泉州市丰泽区医院',
            '南平市第二医院',
            '南平市妇幼保健院',
            '南平市中医院〓南平市人民医院',
            '中国人民解放军第九二医院',
            '赣州市妇幼保健院',
            '赣南中西医结合医院（原赣州市人民医院分院）',
            '赣州市中医院〓赣州市骨科医院',
            '南康区第一人民医院',
            '南康市中医院',
            '河南科技大学第二附属医院〓洛阳市第四人民医院',
            '洛阳烧伤医院',
            '中信重型机械公司中心医院',
            '洛阳市第二中医院',
            '洛阳市第三人民医院(原洛阳铁路中心医院)',
            '洛阳市第五人民医院〓洛阳市精神病院',
            '洛阳市第一人民医院',
            '洛阳市妇女儿童医疗保健中心(原洛阳市妇幼保健院)',
            '洛阳市轴承集团总医院',
            '洛阳轴承集团有限公司总医院',
            '中国人民解放军第五三四医院',
            '平顶山煤业(集团)公司八矿职工医院',
            '平顶山煤业(集团)公司高庄矿中心医院',
            '平顶山煤业(集团)公司一矿职工医院',
            '平顶山市第五人民医院',
            '平顶山市妇幼保健院〓平顶山市第四人民医院',
            '平顶山市中医院',
            '南阳市第三人民医院(原南阳市公费医疗医院)',
            '南阳市第一人民医院',
            '南阳市中医院',
            '南阳卫生学校附属医院',
            '南阳县人民医院',
            '南阳中医中药学校附院',
            '方城县第二人民医院（原方城县公疗医院）',
            '驻马店市第二中医院',
            '驻马店市第四人民医院',
            '驻马店市第一人民医院',
            '丹江口市第一医院',
            '国药东风公司茅箭医院',
            '汉江水利水电（集团）责任公司汉江医院',
            '鄂钢医院（鄂城钢铁厂职工医院）',
            '鄂州市第二医院',
            '鄂州市第三医院',
            '鄂州市妇幼保健院',
            '岳阳监狱医院',
            '岳阳石油化工总厂职工医院',
            '岳阳市长岭炼油化工总厂职工医院',
            '岳阳市第二人民医院〓岳阳市肿瘤医院',
            '岳阳市第三人民医院(原湖南省血吸虫病防治所附属湘岳医院)',
            '岳阳市妇幼保健院',
            '岳阳市湘岳医院',
            '岳阳市中医院',
            '东莞仁康医院',
            '东莞市光华医院',
            '东莞常安医院',
            '企石医院',
            '石龙博爱医院仁济分院',
            '虎门医院树田分院',
            '韶关市铁路医院',
            '核工业四一九职工医院',
            '韶关市妇幼保健院',
            '韶关市红十字会医院',
            '韶关市曲江区中医院',
            '韶关市粤北第二人民医院',
            '韶关市职业病防治院(韶关市第二人民医院,粤北工伤康复中心)',
            '韶关市中医院',
            '深圳市中金岭南股份公司韶关分公司职工医院',
            '深圳流花医院',
            '深圳市宝安区妇幼保健院',
            '深圳市宝安区沙井人民医院',
            '深圳市宝安区松岗人民医院',
            '深圳市第七人民医院〓深圳市盐田区人民医院',
            '深圳市福田区中医院',
            '深圳市康宁医院',
            '深圳市龙岗区妇幼保健院',
            '深圳市龙岗区人民医院',
            '深圳市职业病防治院(原深圳铁路医院)',
            '深圳招商局蛇口工业区联合医院',
            '汕头市潮阳区人民医院',
            '汕头市妇幼保健院〓汕头市妇女儿童医院',
            '汕头市金平区人民医院',
            '汕头市龙湖区人民医院',
            '汕头市中医院',
            '东莞光明眼科医院',
            '东莞三局医院',
            '东莞市东华医院',
            '东莞市妇幼保健院',
            '东莞市黄江医院',
            '东莞市第六人民医院（东莞市慢性病防治院）',
            '东莞市桥头医院',
            '东莞市第三人民医院（东莞市石龙人民医院）',
            '东莞市第五人民医院（东莞市太平人民医院）',
            '东莞市莞城人民医院',
            '东莞市第七人民医院（东莞市新涌医院）',
            '东莞市樟木头石新医院',
            '柳州市红十字会医院〓柳州市眼科医院',
            '柳州市职工疗养院〓广西地质职工医院',
            '柳州市中西医结合医院',
            '柳州卫校附属医院〓柳州市肿瘤医院',
            '桂林市口腔医院',
            '玉林市第二人民医院',
            '玉林市肿瘤医院〓玉林市红十字会医院(原中国人民解放军第一八三医院)',
            '绵阳市第二人民医院〓绵阳市肿瘤医院',
            '绵阳市骨科医院',
            '绵阳市富临中心医院',
            '宝鸡市陈仓区医院',
            '宝鸡市金台医院',
            '宝鸡市康复医院〓宝鸡市精神卫生中心',
            '宝鸡市口腔医院',
            '宝鸡市人民医院',
            '宝鸡市渭滨区妇幼保健院',
            '宝鸡市渭滨医院',
            '宝鸡铁路医院',
            '汉中市第二人民医院〓汉中市传染病医院',
            '汉中市口腔医院',
            '汉中市人民医院',
            '汉中市中医院',
            '天津电力医院',
            '天津市河西区妇产科医院',
            '天津市河西区柳林医院',
            '天津市南开区理疗专科医院',
            '天津市南开区王顶堤医院',
            '天津市新生医院',
            '天津市冶金医院',
            '天津铁路分局天津结核防治疗养院',
            '唐山市汉沽管理区医院',
            '大同机车厂医院',
            '大同康复医院',
            '大同市城区人民医院〓大同市城区妇幼保健站',
            '大同市第六人民医院〓大同市精神病治疗中心',
            '大同市煤炭工业局职工医院',
            '大同市商业职工医院',
            '大同市新荣区人民医院',
            '营口市传染病院',
            '营口市妇产儿童医院',
            '营口市化学纤维厂职工医院',
            '营口市结核病医院',
            '营口市口腔医院',
            '营口市老边区人民医院',
            '吉林市船营区二医院',
            '吉林江北机械厂职工医院',
            '吉林市昌邑区医院',
            '吉林市船营区医院',
            '吉林市船营区中医医院',
            '吉林市丰满区医院',
            '吉林市丰满区中医院',
            '吉林市骨伤医院',
            '吉林市红十字会第一医院',
            '吉林市交通医院',
            '吉林市龙潭区人民医院',
            '吉林市神经精神病总医院',
            '吉林新世纪医院',
            '永吉县中医院',
            '昂昂溪铁路医院',
            '齐齐哈尔碾子山区人民医院',
            '齐齐哈尔市昂溪区人民医院',
            '齐齐哈尔市财贸职工医院',
            '大庆市大同区医院',
            '大庆市红岗人民医院',
            '大庆市龙凤区人民医院',
            '大庆市让胡路区医院',
            '吴江市康复医院(原吴江市庞山湖医院)',
            '吴江市第二人民医院',
            '吴江市第三人民医院',
            '吴江市中医院',
            '南平市延平区医院',
            '赣州市三六二医院〓赣州市肿瘤医院',
            '江西医学院附属第四医院(原南昌铁路局南昌铁路中心医院)',
            '河南柴油机集团有限公司职工医院',
            '洛阳白马集团职工医院(原洛阳市棉纺厂职工医院)',
            '洛阳钢铁集团有限责任公司职工医院',
            '洛阳机车厂职工医院',
            '洛阳耐火材料集团有限责任公司职工医院',
            '洛阳南峰航空精密机电有限公司职工医院',
            '洛阳市浮法玻璃集团有限责任公司职工医院',
            '洛阳市机车厂职工医院',
            '洛阳市吉利区人民医院',
            '洛阳市耐火材料厂职工医院',
            '洛阳铜加工集团有限责任公司职工医院',
            '铁道部第十五工程局医院',
            '中国建筑第二工程局第二工程公司职工医院',
            '洛阳石化医院（中国石油化工集团洛阳石油化工总厂医院）',
            '平顶山市卫东区人民医院',
            '平顶山市新华区人民医院',
            '南阳市宛城区第一医院',
            '中国建筑第七工程局职工医院',
            '驻马店市第二人民医院〓驻马店市精神病医院',
            '驻马店市第三人民医院〓驻马店市公费医疗医院',
            '君山区第二人民医院',
            '岳阳市君山区第一人民医院',
            '汕头大学医学院附属肿瘤医院',
            '汕头市潮南区人民医院',
            '鹅山博爱医院(原柳州机车车辆厂职工医院)',
            '宝鸡市陈仓区中医医院',
            '汉中市汉台区妇幼保健院',
            '汉中市康复医院',
            '中核国营八一三厂医院',
            '吉林铁合金厂职工医院',
            '洛阳市第二商业医院',
            '河南省第六建筑工程公司职工医院',
            '洛阳北方企业集团有限公司职工医院',
            '大庆石油管理局第二医院〓大庆市第二医院〓大庆市传染病医院',
            '大庆石油管理局第三医院〓大庆市第三医院〓大庆市精神卫生中心',
            '大庆市第四医院',
            '大庆市人民医院〓哈尔滨医科大学附属第五医院',
            '大庆油田总医院龙南医院',
            '苏州市口腔医院',
            '中国人民解放军一二三医院',
            '平顶山市第二人民医院',
            '深圳恒生医院',
            '天津市安定医院',
            '天津市长征医院',
            '天津市海河医院（天津市肺科医院）',
            '天津市公安局安康医院',
            '天津市河西肿瘤医院',
            '天津市劳动卫生职业病防治院',
            '天津市人民医院滨江分院',
            '天津市心理卫生医院',
            '天津市整形外科医院',
            '天津市中医院',
            '天津医科大学代谢病医院',
            '天津医科大学第三附属医院',
            '开滦总医院',
            '开滦有限责任公司医院',
            '唐山市第四医院',
            '唐山市人民医院',
            '唐山市中医医院',
            '大同市第三人民医院',
            '营口市中心医院',
            '北华大学医学院附属医院',
            '吉化集团公司总医院',
            '吉林市第二中心医院',
            '吉林市中心医院',
            '中国人民解放军第二二二医院',
            '中国人民解放军空军吉林医院',
            '齐齐哈尔市中医院',
            '齐齐哈尔市第一医院',
            '齐齐哈尔市协育友好医院（齐齐哈尔市第二医院）',
            '齐齐哈尔医学院第二附属医院',
            '齐齐哈尔医学院第三附属医院（齐齐哈尔市肿瘤医院）',
            '齐齐哈尔医学院第一附属医院',
            '大庆市中医院',
            '苏州大学附属第二医院',
            '苏州大学附属儿童医院',
            '苏州大学附属第一医院',
            '苏州市立医院',
            '苏州市吴中人民医院',
            '苏州市中医医院',
            '中国人民解放军第一00医院',
            '浙江中医学院附属第三医院',
            '蚌埠市第三人民医院',
            '蚌埠医学院第二附属医院(原蚌埠铁路分局中心医院)',
            '蚌埠医学院附属医院',
            '阜阳市中医院',
            '福建医科大学附属第一医院闽南分院',
            '福建医科大学附属第二医院',
            '赣州市人民医院',
            '河南第二荣康医院',
            '河南科技大学第一附属医院',
            '洛阳市高等专科学校附属医院',
            '洛阳市正骨医院',
            '洛阳市中心医院',
            '中国人民解放军150中心医院',
            '中国平煤神马医疗集团总医院(平煤集团总医院)',
            '南阳市南石医院〓南阳烧伤脑血管病专科医院',
            '南阳市中心医院',
            '驻马店市中医院(原驻马店地区中医院)',
            '十堰市人民医院',
            '十堰市太和医院',
            '鄂州市中心医院',
            '鄂州市中医医院',
            '岳阳市第一人民医院',
            '暨南大学医学院深圳眼科中心〓深圳市眼科医院',
            '深圳市宝安区中医院',
            '深圳市第三人民医院〓深圳市东湖医院〓深圳市传染病医院',
            '汕头大学医学院第二附属医院',
            '汕头大学医学院第一附属医院',
            '东莞康华医院',
            '东莞市常平医院',
            '东莞市厚街医院（东莞市厚街方树泉医院）',
            '东莞市第一人民医院（东莞市人民医院）',
            '东莞市中医院',
            '广西龙泉山医院',
            '广西医科大学第四附属医院〓柳州市工人医院',
            '广西医科大学附属第五医院〓柳州市人民医院',
            '柳州市第三人民医院（柳铁中心医院）',
            '柳州市妇幼保健院',
            '柳州医学高等专科学校第一附属医院',
            '桂林南溪山医院',
            '桂林市第二人民医院',
            '桂林市人民医院',
            '桂林市中医院',
            '桂林医学院附属医院',
            '解放军一八一医院',
            '玉林市第一人民医院',
            '玉林市中医院',
            '绵阳市中心医院',
            '绵阳市中医院〓成都中医药大学附属绵阳医院',
            '宝鸡市妇幼保健院(包括宝鸡市儿童医院)',
            '宝鸡市中心医院',
            '宝鸡市中医院',
            '汉中三二0一医院',
            '汉中市中心医院',
            '天津市安宁医院',
            '天津市天和医院',
            '大同煤矿集团有限责任公司总医院',
            '大同市第五人民医院',
            '中国人民解放军第三二二医院',
            '营口市中医院',
            '苏州市第三人民医院（苏州市立医院北区）',
            '苏州市第五人民医院（苏州市传染病医院）',
            '蚌埠市第一人民医院',
            '泉州市第三医院',
            '泉州市第一医院',
            '中国人民解放军第一八零医院（福建泉州海峡医院）180',
            '南平市第一医院',
            '河南科技大学第三附属医院〓东方医院',
            '广东医学院附属韶关医院〓韶关市第一人民医院',
            '汕头大学医学院眼科中心（汕头大学医学院第五附属医院）',
            '汕头市第二人民医院〓汕头市红十字会医院',
            '汕头市第四人民医院',
            '柳州市龙潭医院',
            '桂林市第五人民医院（桂林市中西医结合医院、桂林市肿瘤医院）',
            '绵阳市人民医院',
            '绵阳四0四医院（川北医学院附属第二医院）',
            '北京老年医院(海淀）',
            '泉州市儿童医院〓泉州市妇幼保健院',
            '深圳市福永医院',
            '深圳市第八人民医院〓深圳市宝安区人民医院〓南方医科大学深圳宝安医院',
            '天津市北辰区中医院',
            '莆田市第一医院',
            '桂林市第四人民医院（桂林市红十字会博爱医院、桂林市妇女儿童医院、桂林市妇幼保健院）',
            '泉州市正骨医院',
            '汉中职业技术学院附属医院（汉中市卫生学校附属医院',
            '汕头市中心医院',
            '大庆油田总医院',
            '南阳市第二人民医院',
            '中国人民解放军七六八医院',
            '南阳医学高等专科学校第一附属医院',
            '驻马店市中心医院',
            '四川省科学城医院',
            '赣州市立医院（赣南医学院附属市立医院）',
            '天津市职业病防治院（天津市工人医院）',
            '大化集团有限责任公司医院',
            '大连海洋渔业集团公司医院（大连辽渔医院）',
            '大连机车医院',
            '大连市第五人民医院〓大连市胸科肿瘤医院',
            '武警辽宁总队大连医院',
            '宁波市第六医院',
            '宁波市第九医院（宁波市第一医院江北分院、江北区人民医院）',
            '辽宁医学院附属第二医院=辽宁医学院附属口腔医院',
            '汕头市潮阳区大峰医院',
            '大连大学附属口腔医院〓大连市口腔医院',
            '大连市第六人民医院',
            '大连市妇产医院〓大连市妇幼保健院',
            '大连市皮肤病医院',
            '天津市南开医院',
            '天津医科大学总医院',
            '大连大学附属新华医院',
            '大连大学附属中山医院（包括造船分院）',
            '大连市儿童医院',
            '大连市友谊医院',
            '大连市中心医院',
            '大连市中医医院',
            '大连医科大学附属第一医院',
            '宁波大学医学院附属医院〓宁波市第三医院',
            '宁波市第二医院',
            '宁波市第一医院',
            '宁波市医疗中心李惠利医院',
            '宁波市中医院',
            '宁波市妇女儿童医院',
            '宁波市眼科医院',
            '宁波市鄞州区第二医院（宁波市泌尿肾病医院）',
            '宁波市鄞州人民医院',
            '南方医科大学深圳医院',
            '大连市第四人民医院〓大连市职业病防治院',
            '大连市第三人民医院',
            '大连市妇女儿童医疗中心',
            '大连医科大学附属第二医院',
            '大连市第二人民医院',
            '宁波市李惠利东部医院']
    }
}